import EyeOffImage from './assets/eye-off.svg'
import { getSrcFromImport } from './utils'

type IconProps = React.ComponentProps<'svg'>

export function BoldIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 4V20M9.5 4H15.5C17.7091 4 19.5 5.79086 19.5 8C19.5 10.2091 17.7091 12 15.5 12H9.5H16.5C18.7091 12 20.5 13.7909 20.5 16C20.5 18.2091 18.7091 20 16.5 20H9.5M9.5 4V20M9.5 4H4M9.5 20H4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ItalicIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.25 4L7.25 20M16.75 4L10.75 20M19.5 4L9.5 4M14.5 20H4.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function UnderlineIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 4V10C19 13.866 15.866 17 12 17C8.13401 17 5 13.866 5 10V4M8.5 4V10C8.5 13.2218 10.6766 15.9352 13.6395 16.7501M4 21H20M3 4L10.5 4M17 4L21 4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function LetterSpacingIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 18H22M2 18L5 15M2 18L5 21M22 18L19 15M22 18L19 21M7 3H17M12 3V14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function LetterSpacing02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 18H22M2 18L5 15M2 18L5 21M22 18L19 15M22 18L19 21M7 3H17M12 3V14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function LineHeightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 13H15M7 17L11.2717 7.60224C11.5031 7.09323 11.6188 6.83872 11.7791 6.75976C11.9184 6.69115 12.0816 6.69115 12.2209 6.75976C12.3812 6.83872 12.4969 7.09323 12.7283 7.60224L17 17M21 21H3M21 3H3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function DotsVerticalIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function AlignCenterIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 10H6M21 6H3M21 14H3M18 18H6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function AlignLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 10H3M20 6H3M20 14H3M16 18H3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function AlignRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 10H8M21 6H4M21 14H4M21 18H8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function AlignJustifyIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 10H3M21 18H3M21 6H3M21 14H3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CopyIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 2.0028C9.82495 2.01194 9.4197 2.05103 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8.05103 3.4197 8.01194 3.82495 8.0028 4.5M19.5 2.0028C20.1751 2.01194 20.5803 2.05103 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C21.949 3.4197 21.9881 3.82494 21.9972 4.49999M21.9972 13.5C21.9881 14.175 21.949 14.5803 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.5803 15.949 20.1751 15.9881 19.5 15.9972M22 7.99999V9.99999M14.0001 2H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function DotPointsIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 12L9 12M21 6L9 6M21 18L9 18M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12ZM5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6ZM5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function LockUnlocked01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 10V8C7 5.23858 9.23858 3 12 3C14.0503 3 15.8124 4.2341 16.584 6M12 14.5V16.5M8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C17.7202 10 16.8802 10 15.2 10H8.8C7.11984 10 6.27976 10 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function LockUnlocked02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66667 7.33333V5.33333C4.66667 3.49238 6.15905 2 8 2C9.61264 2 10.9578 3.14517 11.2667 4.66667M5.2 14H10.8C11.9201 14 12.4802 14 12.908 13.782C13.2843 13.5903 13.5903 13.2843 13.782 12.908C14 12.4802 14 11.9201 14 10.8V10.5333C14 9.41323 14 8.85318 13.782 8.42535C13.5903 8.04903 13.2843 7.74307 12.908 7.55132C12.4802 7.33333 11.9201 7.33333 10.8 7.33333H5.2C4.0799 7.33333 3.51984 7.33333 3.09202 7.55132C2.71569 7.74307 2.40973 8.04903 2.21799 8.42535C2 8.85318 2 9.41323 2 10.5333V10.8C2 11.9201 2 12.4802 2.21799 12.908C2.40973 13.2843 2.71569 13.5903 3.09202 13.782C3.51984 14 4.0799 14 5.2 14Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Lock01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M 7 10 V 8 C 7 5.2386 9.2386 3 12 3 C 14.0503 3 17 4 17 10 M 12 14.5 V 16.5 M 8.8 21 H 15.2 C 16.8802 21 17.7202 21 18.362 20.673 C 18.9265 20.3854 19.3854 19.9265 19.673 19.362 C 20 18.7202 20 17.8802 20 16.2 V 14.8 C 20 13.1198 20 12.2798 19.673 11.638 C 19.3854 11.0735 18.9265 10.6146 18.362 10.327 C 17.7202 10 16.8802 10 15.2 10 H 8.8 C 7.1198 10 6.2798 10 5.638 10.327 C 5.0735 10.6146 4.6146 11.0735 4.327 11.638 C 4 12.2798 4 13.1198 4 14.8 V 16.2 C 4 17.8802 4 18.7202 4.327 19.362 C 4.6146 19.9265 5.0735 20.3854 5.638 20.673 C 6.2798 21 7.1198 21 8.8 21 Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function LockUnlocked03Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66675 7.33333V5.33333C4.66675 3.49238 6.15913 2 8.00008 2C9.61272 2 10.9579 3.14517 11.2667 4.66667M5.86675 14H10.1334C11.2535 14 11.8136 14 12.2414 13.782C12.6177 13.5903 12.9237 13.2843 13.1154 12.908C13.3334 12.4802 13.3334 11.9201 13.3334 10.8V10.5333C13.3334 9.41323 13.3334 8.85318 13.1154 8.42535C12.9237 8.04903 12.6177 7.74307 12.2414 7.55132C11.8136 7.33333 11.2535 7.33333 10.1334 7.33333H5.86675C4.74664 7.33333 4.18659 7.33333 3.75877 7.55132C3.38244 7.74307 3.07648 8.04903 2.88474 8.42535C2.66675 8.85318 2.66675 9.41323 2.66675 10.5333V10.8C2.66675 11.9201 2.66675 12.4802 2.88474 12.908C3.07648 13.2843 3.38244 13.5903 3.75877 13.782C4.18659 14 4.74664 14 5.86675 14Z"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Lock03Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3334 7.33333V5.33333C11.3334 3.49238 9.84103 2 8.00008 2C6.15913 2 4.66675 3.49238 4.66675 5.33333V7.33333M5.86675 14H10.1334C11.2535 14 11.8136 14 12.2414 13.782C12.6177 13.5903 12.9237 13.2843 13.1154 12.908C13.3334 12.4802 13.3334 11.9201 13.3334 10.8V10.5333C13.3334 9.41323 13.3334 8.85318 13.1154 8.42535C12.9237 8.04903 12.6177 7.74307 12.2414 7.55132C11.8136 7.33333 11.2535 7.33333 10.1334 7.33333H5.86675C4.74664 7.33333 4.18659 7.33333 3.75877 7.55132C3.38244 7.74307 3.07648 8.04903 2.88474 8.42535C2.66675 8.85318 2.66675 9.41323 2.66675 10.5333V10.8C2.66675 11.9201 2.66675 12.4802 2.88474 12.908C3.07648 13.2843 3.38244 13.5903 3.75877 13.782C4.18659 14 4.74664 14 5.86675 14Z"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function TrashIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6M10 10.5V15.5M14 10.5V15.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function AlignBottom01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 21H21M12 3V17M12 17L19 10M12 17L5 10"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function AlignHorizontalCentre01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3V21M22 12H15.5M15.5 12L19.5 16M15.5 12L19.5 8M2 12H8.5M8.5 12L4.5 16M8.5 12L4.5 8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function AlignLeft01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 3V21M21 12H7M7 12L14 19M7 12L14 5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function AlignRight01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 21V3M3 12H17M17 12L10 5M17 12L10 19"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function AlignTopArrow01Icon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 2.5H2.5M10 17.5V5.83333M10 5.83333L4.16667 11.6667M10 5.83333L15.8333 11.6667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function AlignVerticalCenter01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 12H21M12 2V8.5M12 8.5L16 4.5M12 8.5L8 4.5M12 22V15.5M12 15.5L16 19.5M12 15.5L8 19.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function DistributeSpacingVerticalIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 3H3M21 21H3M5 12C5 11.0681 5 10.6022 5.15224 10.2346C5.35523 9.74458 5.74458 9.35523 6.23463 9.15224C6.60218 9 7.06812 9 8 9L16 9C16.9319 9 17.3978 9 17.7654 9.15224C18.2554 9.35523 18.6448 9.74458 18.8478 10.2346C19 10.6022 19 11.0681 19 12C19 12.9319 19 13.3978 18.8478 13.7654C18.6448 14.2554 18.2554 14.6448 17.7654 14.8478C17.3978 15 16.9319 15 16 15L8 15C7.06812 15 6.60218 15 6.23463 14.8478C5.74458 14.6448 5.35523 14.2554 5.15224 13.7654C5 13.3978 5 12.9319 5 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function DistributeSpacingHorizontalIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 21V3M3 21V3M9 8V16C9 16.9319 9 17.3978 9.15224 17.7654C9.35523 18.2554 9.74458 18.6448 10.2346 18.8478C10.6022 19 11.0681 19 12 19C12.9319 19 13.3978 19 13.7654 18.8478C14.2554 18.6448 14.6448 18.2554 14.8478 17.7654C15 17.3978 15 16.9319 15 16V8C15 7.06812 15 6.60218 14.8478 6.23463C14.6448 5.74458 14.2554 5.35523 13.7654 5.15224C13.3978 5 12.9319 5 12 5C11.0681 5 10.6022 5 10.2346 5.15224C9.74458 5.35523 9.35523 5.74458 9.15224 6.23463C9 6.60218 9 7.06812 9 8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function DropperIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2053_28361)">
        <path
          d="M7.00065 4.33331L11.6673 8.99998M1.33398 14.6666C1.33398 14.6666 4.33398 14.3333 6.00065 12.6666L14.0007 4.66665C14.737 3.93027 14.737 2.73636 14.0007 1.99998C13.2643 1.2636 12.0704 1.2636 11.334 1.99998L3.33398 9.99998C1.66732 11.6666 1.33398 14.6666 1.33398 14.6666Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2053_28361">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function File02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 11H8M10 15H8M16 7H8M20 6.8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Save02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 8H8.6C8.03995 8 7.75992 8 7.54601 7.89101C7.35785 7.79513 7.20487 7.64215 7.10899 7.45399C7 7.24008 7 6.96005 7 6.4V3M17 21V14.6C17 14.0399 17 13.7599 16.891 13.546C16.7951 13.3578 16.6422 13.2049 16.454 13.109C16.2401 13 15.9601 13 15.4 13H8.6C8.03995 13 7.75992 13 7.54601 13.109C7.35785 13.2049 7.20487 13.3578 7.10899 13.546C7 13.7599 7 14.0399 7 14.6V21M21 9.32548V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H14.6745C15.1637 3 15.4083 3 15.6385 3.05526C15.8425 3.10425 16.0376 3.18506 16.2166 3.29472C16.4184 3.4184 16.5914 3.59135 16.9373 3.93726L20.0627 7.06274C20.4086 7.40865 20.5816 7.5816 20.7053 7.78343C20.8149 7.96237 20.8957 8.15746 20.9447 8.36154C21 8.59171 21 8.8363 21 9.32548Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function EyeIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.61342 8.47415C1.52262 8.33039 1.47723 8.25851 1.45182 8.14764C1.43273 8.06436 1.43273 7.93303 1.45182 7.84975C1.47723 7.73889 1.52262 7.66701 1.61341 7.52325C2.36369 6.33526 4.59693 3.33203 8.00027 3.33203C11.4036 3.33203 13.6369 6.33526 14.3871 7.52325C14.4779 7.66701 14.5233 7.73889 14.5487 7.84975C14.5678 7.93303 14.5678 8.06436 14.5487 8.14764C14.5233 8.25851 14.4779 8.33039 14.3871 8.47415C13.6369 9.66214 11.4036 12.6654 8.00027 12.6654C4.59693 12.6654 2.36369 9.66214 1.61342 8.47415Z"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00027 9.9987C9.10484 9.9987 10.0003 9.10327 10.0003 7.9987C10.0003 6.89413 9.10484 5.9987 8.00027 5.9987C6.8957 5.9987 6.00027 6.89413 6.00027 7.9987C6.00027 9.10327 6.8957 9.9987 8.00027 9.9987Z"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function EyeOffIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.16196 3.39488C7.4329 3.35482 7.7124 3.33333 8.00028 3.33333C11.4036 3.33333 13.6369 6.33656 14.3871 7.52455C14.4779 7.66833 14.5233 7.74023 14.5488 7.85112C14.5678 7.93439 14.5678 8.06578 14.5487 8.14905C14.5233 8.25993 14.4776 8.3323 14.3861 8.47705C14.1862 8.79343 13.8814 9.23807 13.4777 9.7203M4.48288 4.47669C3.0415 5.45447 2.06297 6.81292 1.61407 7.52352C1.52286 7.66791 1.47725 7.74011 1.45183 7.85099C1.43273 7.93426 1.43272 8.06563 1.45181 8.14891C1.47722 8.25979 1.52262 8.33168 1.61342 8.47545C2.36369 9.66344 4.59694 12.6667 8.00028 12.6667C9.37255 12.6667 10.5546 12.1784 11.5259 11.5177M2.00028 2L14.0003 14M6.58606 6.58579C6.22413 6.94772 6.00028 7.44772 6.00028 8C6.00028 9.10457 6.89571 10 8.00028 10C8.55256 10 9.05256 9.77614 9.41449 9.41421"
        stroke="currentColor"
        strokeWidth="0.886667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

EyeOffIcon.src = getSrcFromImport(EyeOffImage)

export function Repeat02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 1L13 4M13 4L10 7M13 4H5.8C4.11984 4 3.27976 4 2.63803 4.32698C2.07354 4.6146 1.6146 5.07354 1.32698 5.63803C1 6.27976 1 7.11984 1 8.8V14.5C1 14.9644 1 15.1966 1.02567 15.3916C1.2029 16.7378 2.26222 17.7971 3.60842 17.9743C3.80337 18 4.03558 18 4.5 18M9 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.5C21 7.03558 21 6.80337 20.9743 6.60842C20.7971 5.26222 19.7378 4.2029 18.3916 4.02567C18.1966 4 17.9644 4 17.5 4M9 18L12 21M9 18L12 15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function GridIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V8.4C3 8.96005 3 9.24008 3.10899 9.45399C3.20487 9.64215 3.35785 9.79513 3.54601 9.89101C3.75992 10 4.03995 10 4.6 10H8.4C8.96005 10 9.24008 10 9.45399 9.89101C9.64215 9.79513 9.79513 9.64215 9.89101 9.45399C10 9.24008 10 8.96005 10 8.4V4.6C10 4.03995 10 3.75992 9.89101 3.54601C9.79513 3.35785 9.64215 3.20487 9.45399 3.10899C9.24008 3 8.96005 3 8.4 3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4 3H15.6C15.0399 3 14.7599 3 14.546 3.10899C14.3578 3.20487 14.2049 3.35785 14.109 3.54601C14 3.75992 14 4.03995 14 4.6V8.4C14 8.96005 14 9.24008 14.109 9.45399C14.2049 9.64215 14.3578 9.79513 14.546 9.89101C14.7599 10 15.0399 10 15.6 10H19.4C19.9601 10 20.2401 10 20.454 9.89101C20.6422 9.79513 20.7951 9.64215 20.891 9.45399C21 9.24008 21 8.96005 21 8.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4 14H15.6C15.0399 14 14.7599 14 14.546 14.109C14.3578 14.2049 14.2049 14.3578 14.109 14.546C14 14.7599 14 15.0399 14 15.6V19.4C14 19.9601 14 20.2401 14.109 20.454C14.2049 20.6422 14.3578 20.7951 14.546 20.891C14.7599 21 15.0399 21 15.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V15.6C21 15.0399 21 14.7599 20.891 14.546C20.7951 14.3578 20.6422 14.2049 20.454 14.109C20.2401 14 19.9601 14 19.4 14Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.4 14H4.6C4.03995 14 3.75992 14 3.54601 14.109C3.35785 14.2049 3.20487 14.3578 3.10899 14.546C3 14.7599 3 15.0399 3 15.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H8.4C8.96005 21 9.24008 21 9.45399 20.891C9.64215 20.7951 9.79513 20.6422 9.89101 20.454C10 20.2401 10 19.9601 10 19.4V15.6C10 15.0399 10 14.7599 9.89101 14.546C9.79513 14.3578 9.64215 14.2049 9.45399 14.109C9.24008 14 8.96005 14 8.4 14Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Image03Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.27209 20.7279L10.8686 14.1314C11.2646 13.7354 11.4627 13.5373 11.691 13.4632C11.8918 13.3979 12.1082 13.3979 12.309 13.4632C12.5373 13.5373 12.7354 13.7354 13.1314 14.1314L19.6839 20.6839M14 15L16.8686 12.1314C17.2646 11.7354 17.4627 11.5373 17.691 11.4632C17.8918 11.3979 18.1082 11.3979 18.309 11.4632C18.5373 11.5373 18.7354 11.7354 19.1314 12.1314L22 15M10 9C10 10.1046 9.10457 11 8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7C9.10457 7 10 7.89543 10 9ZM6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V7.8C22 6.11984 22 5.27976 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3H6.8C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8V16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Shuffle01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 15L21 18M21 18L18 21M21 18H18.5689C17.6297 18 17.1601 18 16.7338 17.8705C16.3564 17.7559 16.0054 17.5681 15.7007 17.3176C15.3565 17.0348 15.096 16.644 14.575 15.8626L14.3333 15.5M18 3L21 6M21 6L18 9M21 6H18.5689C17.6297 6 17.1601 6 16.7338 6.12945C16.3564 6.24406 16.0054 6.43194 15.7007 6.68236C15.3565 6.96523 15.096 7.35597 14.575 8.13744L9.42496 15.8626C8.90398 16.644 8.64349 17.0348 8.29933 17.3176C7.99464 17.5681 7.64357 17.7559 7.2662 17.8705C6.83994 18 6.37033 18 5.43112 18H3M3 6H5.43112C6.37033 6 6.83994 6 7.2662 6.12945C7.64357 6.24406 7.99464 6.43194 8.29933 6.68236C8.64349 6.96523 8.90398 7.35597 9.42496 8.13744L9.66667 8.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function RatioSquareIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 1H3C1.89543 1 1 1.89543 1 3V7" stroke="currentColor" strokeWidth="2" />
      <path d="M17 7L17 3C17 1.89543 16.1046 1 15 1L11 1" stroke="currentColor" strokeWidth="2" />
      <path
        d="M11 17L15 17C16.1046 17 17 16.1046 17 15L17 11"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path d="M1 11L1 15C1 16.1046 1.89543 17 3 17L7 17" stroke="currentColor" strokeWidth="2" />
    </svg>
  )
}

export function RatioPortrait02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 1H6C4.89543 1 4 1.89543 4 3V7" stroke="currentColor" strokeWidth="2" />
      <path d="M14 7L14 3C14 1.89543 13.1046 1 12 1L10 1" stroke="currentColor" strokeWidth="2" />
      <path
        d="M10 17L12 17C13.1046 17 14 16.1046 14 15L14 11"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path d="M4 11L4 15C4 16.1046 4.89543 17 6 17L8 17" stroke="currentColor" strokeWidth="2" />
    </svg>
  )
}

export function RatioLandscape01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 4H3C1.89543 4 1 4.89543 1 6V7" stroke="currentColor" strokeWidth="2" />
      <path d="M17 7L17 6C17 4.89543 16.1046 4 15 4L11 4" stroke="currentColor" strokeWidth="2" />
      <path
        d="M11 14L15 14C16.1046 14 17 13.1046 17 12L17 11"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path d="M1 11L1 12C1 13.1046 1.89543 14 3 14L7 14" stroke="currentColor" strokeWidth="2" />
    </svg>
  )
}

export function FontSansSerifIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.24609 20.7422C4.33724 22.3698 4.72135 23.6914 5.39844 24.707C6.6875 26.6081 8.95964 27.5586 12.2148 27.5586C13.6732 27.5586 15.0013 27.3503 16.1992 26.9336C18.5169 26.1263 19.6758 24.681 19.6758 22.5977C19.6758 21.0352 19.1875 19.9219 18.2109 19.2578C17.2214 18.6068 15.6719 18.0404 13.5625 17.5586L9.67578 16.6797C7.13672 16.1068 5.33984 15.4753 4.28516 14.7852C2.46224 13.5872 1.55078 11.7969 1.55078 9.41406C1.55078 6.83594 2.44271 4.72005 4.22656 3.06641C6.01042 1.41276 8.53646 0.585938 11.8047 0.585938C14.8125 0.585938 17.3646 1.3151 19.4609 2.77344C21.5703 4.21875 22.625 6.53646 22.625 9.72656H18.9727C18.7773 8.1901 18.3607 7.01172 17.7227 6.19141C16.5378 4.69401 14.526 3.94531 11.6875 3.94531C9.39583 3.94531 7.7487 4.42708 6.74609 5.39062C5.74349 6.35417 5.24219 7.47396 5.24219 8.75C5.24219 10.1562 5.82812 11.1849 7 11.8359C7.76823 12.2526 9.50651 12.7734 12.2148 13.3984L16.2383 14.3164C18.1784 14.7591 19.6758 15.3646 20.7305 16.1328C22.5534 17.474 23.4648 19.4206 23.4648 21.9727C23.4648 25.1497 22.306 27.4219 19.9883 28.7891C17.6836 30.1562 15.0013 30.8398 11.9414 30.8398C8.3737 30.8398 5.58073 29.9284 3.5625 28.1055C1.54427 26.2956 0.554688 23.8411 0.59375 20.7422H4.24609Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function FontSlabSerifIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.34085 28C6.63999 28 3.93914 27.4359 1.23828 26.3077V19.7949H4.3152V24.4103C5.88785 24.9231 7.73401 25.1795 9.85367 25.1795C12.0075 25.1795 13.6656 24.7692 14.828 23.9487C16.0246 23.1282 16.6229 22.1026 16.6229 20.8718C16.6229 20.188 16.4861 19.6068 16.2126 19.1282C15.9733 18.6496 15.5802 18.2222 15.0332 17.8462C14.4861 17.4701 13.7853 17.1111 12.9306 16.7692C12.0759 16.4274 11.0502 16.0684 9.85367 15.6923C8.82802 15.3504 7.78529 14.9744 6.72546 14.5641C5.69982 14.1538 4.74255 13.6581 3.85367 13.0769C2.99897 12.4957 2.29811 11.7778 1.7511 10.9231C1.23828 10.0342 0.981871 8.97436 0.981871 7.74359C0.981871 5.52137 1.88785 3.72649 3.69982 2.35897C5.54597 0.991452 7.99042 0.307692 11.0332 0.307692C13.8366 0.307692 16.3836 0.888889 18.6742 2.05128V8.51282H15.5973V3.94872C14.2981 3.40171 12.64 3.1282 10.6229 3.1282C8.57161 3.1282 6.99897 3.55556 5.90495 4.41026C4.84512 5.23077 4.3152 6.22222 4.3152 7.38462C4.3152 8.13675 4.45196 8.76923 4.72546 9.28205C5.03315 9.76068 5.4776 10.2051 6.05879 10.6154C6.63999 10.9915 7.35794 11.3504 8.21264 11.6923C9.06734 12 10.0759 12.3419 11.2383 12.7179C12.2639 13.0598 13.2896 13.4359 14.3152 13.8462C15.375 14.2564 16.3152 14.7521 17.1357 15.3333C17.9904 15.8803 18.6742 16.5812 19.187 17.4359C19.6998 18.2564 19.9562 19.265 19.9562 20.4615C19.9562 22.8547 19.0161 24.7179 17.1357 26.0513C15.2554 27.3504 12.6571 28 9.34085 28Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function FontSerifIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 21 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.4664 2.56L18.5064 8.2C18.0264 6.96 16.9464 5.56 15.3064 4.04C13.9064 2.68 12.3064 1.8 10.4264 1.4C8.54641 0.999998 6.94641 1.2 5.54641 2C3.98641 2.96 3.26641 4.92 3.58641 6.88C4.02641 9.64 6.34641 11.44 10.5064 12.32C18.1464 13.92 20.9064 16.8 20.3064 22.04C20.1064 24.64 19.0664 26.52 17.2264 27.76C15.3864 28.96 13.1864 29.56 10.6664 29.56C6.30641 29.52 2.82641 28.48 0.186406 26.52L0.106406 18.92C0.946406 21.24 2.26641 23.28 4.06641 25C5.90641 26.72 7.90641 27.84 10.1064 28.36C12.2664 28.8 14.1464 28.72 15.7464 28.04C17.3864 27.36 18.2264 26.04 18.3064 24.12C18.3864 22.44 17.7864 20.96 16.4664 19.68C15.1464 18.4 12.7064 17.36 9.10641 16.52C5.94641 15.76 3.78641 14.68 2.62641 13.28C1.46641 11.84 0.906406 10.08 1.02641 7.96C1.10641 5.72 2.02641 3.92 3.82641 2.6C5.62641 1.24 7.90641 0.559999 10.6664 0.599998C13.5064 0.599998 16.3464 1.44 17.5864 2.08L18.4664 2.56Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function FontDisplayIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 22 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4998 29.56C5.93984 29.56 2.05984 26.92 0.499844 22.64L5.21984 19.88C6.29984 22.72 8.45984 24.16 11.6598 24.16C14.7398 24.16 16.1398 22.92 16.1398 21.2C16.1398 20.2 15.6998 19.44 14.8198 18.92C13.9398 18.36 12.3798 17.76 10.0998 17.12C7.57984 16.36 6.05984 15.76 4.29984 14.52C2.57984 13.24 1.65984 11.32 1.65984 8.76C1.65984 6.24 2.53984 4.2 4.33984 2.72C6.13984 1.2 8.33984 0.439998 10.8598 0.439998C15.3798 0.439998 18.9398 2.76 20.8598 6.72L16.2198 9.4C15.0998 7 13.2998 5.8 10.8598 5.8C8.57984 5.8 7.17984 6.96 7.17984 8.6C7.17984 9.48 7.53984 10.2 8.25984 10.76C9.01984 11.28 10.4198 11.88 12.4998 12.52L14.4198 13.16C14.8598 13.28 15.4598 13.52 16.2198 13.84C16.9798 14.12 17.5798 14.4 17.9798 14.68C18.8198 15.2 20.0998 16.2 20.6198 17.16C21.2198 18.12 21.6598 19.52 21.6598 21.12C21.6598 23.72 20.6998 25.76 18.8198 27.28C16.9398 28.8 14.4998 29.56 11.4998 29.56Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function FontHandwrittenIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 25 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1269 29.6H11.2069C11.1669 29.56 11.1669 29.56 11.1669 29.56C11.1269 29.56 11.1269 29.56 11.1269 29.6C11.0469 29.64 11.0069 29.68 10.9669 29.76C10.9269 29.88 11.2069 29.72 11.1669 29.84C11.0069 30.12 10.4069 30.16 10.5269 30.6C10.3669 30.56 10.3669 30.64 10.2469 30.64C10.2469 30.84 10.1669 30.88 10.1269 31.04C9.92688 31.08 10.1669 30.88 10.0469 30.88C9.84688 31 9.84688 31.32 9.48688 31.28C9.36688 31.4 9.56688 31.44 9.40688 31.48V31.44C9.36688 31.44 9.36688 31.48 9.40688 31.48C9.28688 31.76 9.16688 31.72 8.88688 31.76C8.88688 32.08 8.48688 32.04 8.32687 32.16C8.24688 32.16 8.20688 32.08 8.20688 31.96C8.16688 32.08 8.08688 32.08 7.96688 32.12C8.00688 32.32 8.12688 32.08 8.24688 32.2C8.20688 32.32 8.04688 32.48 7.92688 32.36C7.92688 32.48 7.96688 32.52 8.00688 32.52C7.40688 32.8 7.16688 33 6.52688 33.2C6.40688 33.32 6.24688 33.52 6.04688 33.4C5.12688 34 3.80688 34.2 2.68687 34.24C1.16687 33.92 0.766875 32.32 1.08687 30.6C1.72688 28.36 3.80688 27.56 5.56688 26.4C6.40688 26.08 7.28688 25.68 8.20688 25.56C8.16688 25.72 8.24688 25.8 8.44688 25.76C8.28688 25.92 8.12688 26.04 8.00688 26.32C7.24688 26.44 6.64688 26.8 6.16688 27.24C6.28688 27.44 6.36688 27.12 6.56688 27.28C6.72688 27.28 6.80688 27.04 6.64688 27C6.80688 26.88 6.88688 26.6 7.08688 26.72C7.04688 26.92 6.84688 26.92 6.84688 27.12C6.88688 27.24 6.92688 27.08 7.04688 27.12C6.88688 27.24 6.80688 27.36 6.52688 27.48C6.64688 27.64 6.72688 27.4 6.84688 27.44C6.80688 27.72 6.56688 27.64 6.28688 27.76C6.00688 28.28 5.20688 28.36 4.92688 28.88C4.64688 28.88 4.56688 29.08 4.36687 29.12C4.40688 29.28 4.20688 29.24 4.20688 29.4C3.24688 29.96 2.44687 30.8 1.84687 31.88C1.88687 31.92 1.88687 32 1.88687 32.12C2.56687 32.92 4.60688 32.28 5.40688 32.08C5.28688 32.24 5.56688 31.96 5.40688 32.08C5.40688 31.96 5.48688 32.04 5.48688 31.92C5.64688 31.96 5.44688 32 5.56688 32.12C5.88688 31.84 6.44688 31.6 6.88688 31.48C7.20688 31.2 7.64688 30.96 8.00688 30.84C9.08688 30.08 10.0069 29.2 10.9269 28.28C11.2069 27.8 11.3269 27.36 11.7669 27.08C12.2069 26.28 12.4069 25.68 12.4069 24.6C12.2469 23.2 11.3669 22.56 10.7669 21.64C10.7269 21.52 10.6469 21.72 10.6069 21.6C9.80688 20.68 8.80688 20.04 7.80688 19.36C7.68688 19.32 7.68688 19.16 7.56688 19.12C7.52688 19 7.32688 19.08 7.20688 18.96C7.24688 18.96 7.20688 18.92 7.12688 18.84C6.84688 18.64 6.60688 18.56 6.28688 18.44C5.48688 17.84 4.60688 17.28 3.68688 16.8C3.04688 16.2 2.16687 15.84 1.80687 15C1.44687 14.72 1.20687 14.32 1.08687 13.96C0.446875 11.72 1.84687 10 3.04688 8.92C3.04688 8.88 3.08688 8.8 3.12688 8.68C3.40688 8.64 3.40688 8.36 3.72688 8.36C3.84688 8.08 4.20688 7.8 4.64688 7.64C4.80688 7.64 4.60688 7.6 4.64688 7.48C5.24688 7.2 5.60688 6.76 6.24688 6.6C6.36688 6.32 6.76688 6.16 6.92688 6.2C8.20688 5.2 9.84688 4.56 11.4069 3.76C11.5269 3.76 11.4469 3.68 11.4869 3.68C13.0869 3.04 14.6469 2.36 16.3669 1.84C16.3669 1.84 16.3669 1.8 16.3669 1.68C17.0469 1.72 17.6469 1.32 18.2469 1.28C19.2869 0.879998 21.6469 0.239999 22.9669 0.879998C23.0869 0.999999 23.1669 1.04 23.1669 1.2C23.6069 1.32 23.5669 1.76 23.8469 2.04C24.2069 2.48 24.5269 3.2 24.2469 3.72C24.1269 3.84 24.1269 3.96 24.0069 4C23.5669 4.12 23.2869 4.32 22.9669 4.6C22.9669 4.56 22.8869 4.56 22.6869 4.56C22.8869 3.96 23.1269 3.56 23.1669 2.72C20.6469 2.2 18.6069 3.08 16.4469 3.52C16.1669 3.8 15.7269 3.8 15.4469 4C15.3269 4 15.3669 3.92 15.2469 3.92V4.08C14.6069 4.2 13.8869 4.52 13.3669 4.72C13.3669 4.84 13.1669 4.72 13.0469 4.76C12.6069 5.4 11.6869 5.16 11.2469 5.72C11.2069 5.72 11.2069 5.68 11.2069 5.6C11.0869 5.6 11.1669 5.8 11.0469 5.84C10.6069 5.72 10.6069 6.08 10.4069 6.12C10.2469 6.24 10.0869 6.12 9.96688 6.24C9.64688 6.36 9.44688 6.68 9.08688 6.68C9.04688 6.96 8.44688 7.04 8.12688 7.32C7.92688 7.52 7.60688 7.68 7.20688 7.76C7.08688 7.8 7.24688 7.84 7.20688 7.96C5.88688 8.4 5.20688 9.24 4.08688 9.88C4.08688 9.96 4.08688 10 4.12688 9.96C4.12688 10.08 4.08688 10.12 3.96688 10C3.44688 10.44 3.08688 10.84 2.60687 11.28C2.56687 11.4 2.64687 11.36 2.64687 11.48C2.04687 11.92 1.56687 12.56 1.76687 13.52C1.88687 13.8 2.04687 13.92 2.16687 14.2C3.08688 14.64 3.56688 15.4 4.52688 15.72C4.68688 15.92 4.76688 16.08 5.04688 16.12V16.24C5.32688 16.24 5.20688 16.32 5.48688 16.36C5.52688 16.48 5.56688 16.56 5.56688 16.6C6.24688 16.64 6.76688 17.32 7.52688 17.6C8.20688 18.36 9.36688 18.8 10.0469 19.72C11.4869 20.84 12.4469 22.32 12.9669 24.2C12.8069 24.08 12.9269 23.72 12.7669 23.6C12.9669 24.56 12.9669 25.8 12.9669 26.88C12.7669 27.64 12.3669 27.96 12.2469 28.56C12.1669 28.56 12.0869 28.6 12.0469 28.64C11.9269 29.08 11.4869 29.12 11.4869 29.56C11.3269 29.6 11.2469 29.88 11.1269 29.6ZM14.5269 2.96C14.5269 2.92 14.4069 2.92 14.4069 2.96C14.4469 2.96 14.4869 3.08 14.5269 2.96ZM13.9269 3.12C13.8869 3.16 13.8069 3.12 13.8069 3.16C13.8869 3.16 13.9269 3.16 13.9269 3.12ZM13.3269 3.36H13.2469C13.1269 3.4 13.2469 3.48 13.2469 3.36C13.3669 3.32 13.4069 3.52 13.4069 3.36H13.3269ZM12.6469 3.68C12.8069 3.56 12.9269 3.68 12.9669 3.52C12.8469 3.52 12.6469 3.48 12.6469 3.68ZM12.2869 3.76C12.2469 3.72 12.2469 3.72 12.2069 3.72C12.0869 3.84 12.3269 3.88 12.2869 3.76ZM11.8869 3.88V3.96H12.0069V3.88H11.8869ZM11.6069 4.08C11.8069 4.08 11.8869 4.04 11.8469 3.96C11.7269 3.96 11.6469 4 11.6069 4.08ZM11.0069 4.28C10.9669 4.48 10.6869 4.44 10.5669 4.6C10.6069 4.6 10.5669 4.68 10.6869 4.68C10.8069 4.48 11.4469 4.4 11.2469 4.2C11.2869 4.32 11.1269 4.4 11.0069 4.28ZM10.4069 4.64C10.3669 4.68 10.3269 4.72 10.3269 4.68C10.3669 4.68 10.4069 4.68 10.4069 4.64ZM10.1269 4.68C10.2469 4.96 10.4069 4.68 10.1269 4.68V4.68ZM9.52688 4.92C9.48688 5.12 9.72688 5.04 9.88688 5.04C9.76688 4.92 9.92688 4.84 9.76688 4.8C9.76688 4.88 9.68688 4.92 9.52688 4.92ZM10.1669 5.2C10.2869 5.32 10.2469 5 10.2069 5C10.2069 5.12 10.1669 5.08 10.1669 5.2ZM9.84688 5.36C9.84688 5.24 9.96688 5.36 9.96688 5.24C9.92688 5.2 9.68688 5.32 9.84688 5.36ZM11.4069 5.44C11.5669 5.48 11.4869 5.4 11.6069 5.28C11.4869 5.32 11.4069 5.4 11.4069 5.44ZM8.56688 5.52C8.72688 5.56 9.00688 5.48 9.12688 5.32C8.84688 5.36 8.72688 5.36 8.56688 5.52ZM8.36688 5.52V5.6H8.48688C8.48688 5.56 8.44688 5.52 8.36688 5.52ZM9.24688 5.6C9.04688 5.6 8.92687 5.68 8.88688 5.8C9.08688 5.76 9.20688 5.68 9.24688 5.6C9.40688 5.64 9.24688 5.48 9.24688 5.6ZM7.80688 5.92C7.92688 6.04 8.12688 6 8.16688 5.84C8.04688 5.68 7.92688 5.8 7.80688 5.92ZM9.56688 5.8C9.52688 5.8 9.36688 5.72 9.36688 5.84C9.40688 5.96 9.52688 5.92 9.56688 5.8ZM10.1669 5.88C10.2869 5.88 10.2069 5.92 10.3269 5.92C10.4469 5.88 10.4869 5.84 10.5269 5.8C10.3269 5.84 10.2869 5.76 10.1669 5.88ZM8.72688 5.92C8.76688 5.92 8.80688 5.88 8.84688 5.84C8.76688 5.84 8.72688 5.88 8.72688 5.92ZM7.68688 5.92V6.04C7.80688 6.08 7.84688 5.88 7.72688 5.88C7.72688 5.92 7.72688 5.96 7.68688 5.92ZM7.36688 6.12H7.32688C7.32688 6.24 7.48688 6.12 7.52688 6.24C7.40688 6.36 7.16688 6.16 7.12688 6.36C7.44688 6.48 7.68688 6.2 7.40688 6.04C7.36688 6.08 7.36688 6.12 7.36688 6.12ZM7.68688 6.12C7.68688 6.08 7.64688 6.04 7.56688 6.04C7.52688 6.16 7.56688 6.2 7.68688 6.12ZM7.96688 6.28C7.84688 6.28 7.76688 6.32 7.72688 6.36C7.84688 6.48 7.84688 6.32 7.96688 6.28C8.12688 6.28 8.12688 6.16 8.24688 6.12C8.12688 6 8.08688 6.24 7.96688 6.28ZM9.40688 6.24C9.52688 6.24 9.56688 6.2 9.52688 6.12H9.44688C9.44688 6.24 9.40688 6.2 9.40688 6.24ZM6.32688 6.72C6.32688 6.84 6.36688 6.88 6.44688 6.92C6.48688 6.8 6.52688 6.84 6.48688 6.72C6.68688 6.72 6.84688 6.6 6.96688 6.56C6.92688 6.4 7.04688 6.44 7.08688 6.32C6.80688 6.44 6.68688 6.6 6.32688 6.72ZM8.60688 6.36V6.48H8.68688V6.36H8.60688ZM7.52688 6.44V6.56C7.52688 6.52 7.64688 6.48 7.52688 6.44ZM8.80688 6.52C8.76688 6.64 8.84688 6.68 8.96688 6.68C8.92687 6.52 8.84688 6.48 8.80688 6.52ZM7.32688 6.56V6.68C7.36688 6.68 7.36688 6.72 7.40688 6.72C7.40688 6.6 7.36688 6.56 7.32688 6.56ZM8.20688 6.6C8.20688 6.64 8.16688 6.64 8.16688 6.68C8.20688 6.64 8.20688 6.64 8.20688 6.6ZM7.12688 6.72C6.96688 6.76 6.84688 6.88 6.76688 7C6.92688 6.96 7.04688 6.84 7.12688 6.72C7.32688 6.72 7.12688 6.56 7.12688 6.72ZM8.44688 6.72C8.56688 6.72 8.60688 6.72 8.64688 6.68C8.52688 6.64 8.44688 6.64 8.44688 6.72ZM7.60688 6.84C7.72688 6.84 7.68688 6.88 7.80688 6.88C7.84688 6.76 7.64688 6.72 7.60688 6.84ZM8.56688 6.76C8.60688 6.92 8.68688 6.64 8.56688 6.76V6.76ZM5.76688 7.16C5.96688 7.04 6.12688 7.12 6.24688 7.08C6.24688 6.96 6.16688 6.8 6.04688 6.92C6.16688 7.16 5.64688 6.84 5.76688 7.16ZM7.84688 7C8.04688 7 8.16688 6.96 8.20688 6.88C8.08688 6.92 7.88688 6.88 7.84688 7ZM8.48688 6.88C8.44688 6.88 8.40688 6.88 8.40688 6.92C8.44688 6.92 8.48688 6.92 8.48688 6.88ZM7.44688 7.32C7.56688 7.32 7.72688 7.28 7.56688 7.16C7.52688 7.2 7.52688 7.2 7.52688 7.2V7.12C7.52688 7.2 7.48688 7.28 7.44688 7.32ZM5.64688 7.16C5.52688 7.2 5.40688 7.2 5.40688 7.36C5.44688 7.32 5.48688 7.36 5.48688 7.4H5.68687C5.72688 7.28 5.52688 7.28 5.64688 7.16C5.76688 7.12 5.64688 7.12 5.64688 7.16ZM6.20688 7.36C6.24688 7.32 6.36688 7.32 6.32688 7.2C6.20688 7.24 6.16688 7.32 6.20688 7.36ZM7.08688 7.32C6.96688 7.44 7.24688 7.2 7.08688 7.32V7.32ZM6.88688 7.4C7.00688 7.52 7.04688 7.28 6.92688 7.32C6.88688 7.36 6.88688 7.4 6.88688 7.4ZM7.16688 7.4H7.28688H7.16688ZM6.00688 7.4C5.80688 7.48 5.60688 7.6 5.48688 7.72C5.64688 7.76 5.84688 7.56 6.00688 7.4ZM5.16688 7.56C5.12688 7.52 5.08688 7.48 5.04688 7.48C5.04688 7.68 4.88688 7.4 4.84688 7.6C5.04688 7.76 5.32688 7.6 5.44688 7.4H5.24688C5.24688 7.52 5.20688 7.56 5.16688 7.56ZM6.76688 7.48C6.88688 7.64 6.88688 7.36 6.76688 7.48V7.48ZM4.72688 7.84C4.76688 7.8 4.84688 7.8 4.92688 7.84C4.88688 7.8 4.96688 7.72 4.84688 7.72C4.88688 7.84 4.60688 7.68 4.72688 7.84ZM6.28688 7.72C6.24688 7.72 6.24688 7.72 6.24688 7.76C6.28688 7.76 6.28688 7.76 6.28688 7.72ZM4.84688 8.12C5.12688 8 5.36688 8.04 5.48688 7.76C5.20688 7.88 5.04688 8 4.84688 8.12ZM4.48688 8C4.52688 7.88 4.60688 8.16 4.48688 8V8ZM5.92688 8H5.84688C5.88688 8 5.92688 8.12 5.92688 8ZM4.28688 8.04V8.12H4.36687V8.04H4.28688ZM4.40688 8.44C4.60688 8.4 4.72688 8.32 4.84688 8.16H4.60688C4.64688 8.36 4.40688 8.24 4.40688 8.44ZM3.88688 8.36C4.00688 8.56 3.56688 8.48 3.68688 8.6C3.88688 8.6 4.28688 8.28 4.16688 8.64C4.24688 8.64 4.32688 8.6 4.36687 8.48C4.20688 8.48 4.24688 8.28 4.12688 8.24C4.12688 8.52 4.04688 8.32 3.88688 8.36ZM5.36688 8.28C5.28688 8.36 5.24688 8.4 5.24688 8.36C5.28688 8.32 5.32688 8.4 5.36688 8.28ZM5.60688 8.4C5.64688 8.52 5.80688 8.48 5.80688 8.36C5.64688 8.36 5.64688 8.24 5.60688 8.4ZM5.56688 8.36C5.52688 8.36 5.48688 8.36 5.48688 8.4C5.52688 8.4 5.52688 8.4 5.56688 8.36ZM4.84688 8.64V8.68H4.96688V8.64H4.84688ZM3.44688 8.64V8.76H3.52688C3.52688 8.72 3.56688 8.72 3.56688 8.68C3.52688 8.68 3.56688 8.64 3.44688 8.64ZM4.12688 8.64H4.08688C4.04688 8.68 4.00688 8.68 4.00688 8.68C4.08688 8.68 4.12688 8.68 4.12688 8.64ZM5.04688 8.68V8.76H5.16688V8.68H5.04688ZM4.48688 8.8C4.60688 8.8 4.76688 8.84 4.64688 8.72C4.52688 8.72 4.48688 8.76 4.48688 8.8ZM4.84688 8.76C4.72688 8.92 4.72688 8.64 4.84688 8.76V8.76ZM2.76687 9.32C2.80687 9.48 2.80687 9.2 2.76687 9.32V9.32ZM3.12688 9.36C3.00687 9.52 3.24688 9.24 3.12688 9.36V9.36ZM3.08688 9.44C3.04688 9.44 3.00687 9.44 3.00687 9.48H3.04688C3.08688 9.48 3.08688 9.48 3.08688 9.44ZM3.44688 9.64C3.40688 9.64 3.44688 9.56 3.32688 9.56C3.20688 9.68 3.44688 9.76 3.44688 9.64ZM3.32688 10.12C3.36688 10 3.24688 10.08 3.20688 9.96C3.20688 10.08 3.24688 10.12 3.32688 10.12ZM3.08688 10.28C3.04688 10.28 3.00687 10.28 3.00687 10.32H3.04688C3.08688 10.32 3.08688 10.32 3.08688 10.28ZM2.84687 10.44C2.96687 10.56 2.96687 10.28 2.84687 10.44V10.44ZM1.88687 11.2C2.00687 11.32 2.08687 11.08 1.96687 11.04C1.96687 11.04 1.92687 11.08 1.88687 11.2ZM1.84687 11.36C1.96687 11.48 1.96687 11.2 1.84687 11.36V11.36ZM1.96687 11.76C1.84687 11.76 1.92687 11.68 1.80687 11.68C1.68687 11.8 1.96687 11.88 1.96687 11.76ZM4.40688 16.76V16.84H4.52688V16.76H4.40688ZM6.88688 17.56V17.6H6.96688V17.56H6.88688ZM7.16688 17.68C7.20688 17.64 7.16688 17.6 7.04688 17.6C7.00688 17.72 7.04688 17.76 7.16688 17.68ZM6.24688 17.68V17.8H6.28688V17.68H6.24688ZM6.76688 18.04C6.76688 17.92 6.68688 17.88 6.56688 17.88C6.52688 18.04 6.72688 17.92 6.76688 18.04ZM8.00688 18.24V18.28H8.08688V18.24H8.00688ZM7.56688 18.6C7.60688 18.52 7.64688 18.48 7.60688 18.44H7.52688C7.52688 18.52 7.52688 18.56 7.56688 18.6ZM7.20688 18.52C7.16688 18.56 7.12688 18.6 7.12688 18.6C7.16688 18.56 7.20688 18.64 7.20688 18.52ZM7.72688 18.84C7.68688 18.72 7.88688 18.8 7.84688 18.64C7.80688 18.64 7.76688 18.6 7.72688 18.6C7.76688 18.72 7.56688 18.8 7.72688 18.84ZM8.76688 18.72H8.68688C8.64688 18.72 8.64688 18.72 8.64688 18.76C8.52688 18.96 8.88688 18.84 8.76688 18.72ZM8.84688 18.84V18.92H8.88688V18.84H8.84688ZM8.12688 18.92C8.16688 19.12 8.40688 18.96 8.12688 18.92V18.92ZM7.92688 19.12C7.96688 19.28 7.96688 18.96 7.92688 19.12V19.12ZM8.72688 19.32V19.4H8.80688V19.32H8.72688ZM9.12688 19.68C9.08688 19.56 8.96688 19.52 8.84688 19.4C8.88688 19.56 8.96688 19.64 9.12688 19.68ZM9.24688 19.76H9.32688C9.32688 19.72 9.36688 19.72 9.36688 19.68H9.20688C9.16688 19.72 9.20688 19.72 9.24688 19.76ZM9.96688 20.32C10.2469 20.76 10.6469 21 11.0069 21.32C10.8469 21 10.4069 20.6 9.96688 20.32C9.80688 20.2 9.56688 19.72 9.36688 19.92C9.64688 20.04 9.68688 20.32 9.96688 20.32ZM11.3669 21.64C11.3269 21.52 11.2469 21.44 11.1269 21.4C11.1669 21.52 11.2469 21.6 11.3669 21.64ZM11.8469 22.44C11.9669 22.6 11.9669 22.28 11.8469 22.44V22.44ZM7.76688 25.88C7.92688 25.88 8.00688 25.84 8.00688 25.8C7.88688 25.8 7.80688 25.84 7.76688 25.88ZM7.44688 26.12C7.32688 26.16 7.12688 26.12 7.12688 26.32C7.24688 26.2 7.40688 26.24 7.44688 26.12H7.52688C7.52688 26.08 7.52688 26.08 7.52688 26.08V25.96C7.48688 25.96 7.44688 26 7.44688 26.12ZM6.96688 26.24V26.36H7.08688V26.24H6.96688ZM6.52688 26.6C6.72688 26.56 6.84688 26.48 6.88688 26.44C6.84688 26.44 6.84688 26.36 6.72688 26.4C6.84688 26.56 6.48688 26.48 6.52688 26.6ZM6.32688 26.6C6.44688 26.8 6.44688 26.48 6.32688 26.6V26.6ZM6.20688 26.72C6.20688 26.56 6.36688 26.76 6.20688 26.72C6.08688 26.6 6.08688 26.72 5.92688 26.72C5.88688 26.72 5.96688 26.88 5.84688 26.88C5.68687 26.76 5.68687 27.04 5.48688 26.88C5.52688 27.04 5.40688 26.96 5.40688 27.08C5.52688 27.08 5.48688 27.12 5.64688 27.12C5.68687 27 6.08688 27 6.20688 26.72ZM4.96688 27.12C4.92688 27.24 4.88688 27.48 4.76688 27.28C4.72688 27.4 4.48688 27.56 4.60688 27.68C4.60688 27.56 4.80688 27.52 4.80688 27.64C4.92688 27.28 5.12688 27.32 5.40688 27.2C5.28688 27.2 5.40688 27.12 5.28688 27.12C5.24688 27.24 5.08688 27.12 4.96688 27.12ZM5.68687 27.48C5.24688 27.6 4.92688 27.84 4.72688 28.12C4.52688 28.28 4.04688 28.36 4.16688 28.56C4.44688 28.36 4.84688 28.24 5.12688 27.88C5.12688 27.96 5.16688 27.96 5.24688 27.92C5.44688 27.64 6.08688 27.76 6.12688 27.16H6.00688C5.88688 27.44 5.80688 27.32 5.68687 27.48ZM3.04688 28.68C3.48688 28.48 3.92688 28 4.40688 27.8C4.40688 27.68 4.40688 27.64 4.40688 27.64C3.96688 27.96 3.36688 28.24 3.04688 28.68ZM3.96688 28.64C4.08688 28.64 4.12688 28.6 4.12688 28.52H4.00688C4.00688 28.56 3.96688 28.6 3.96688 28.64ZM10.9269 28.76C10.8869 28.64 10.8469 28.56 10.8069 28.56C10.7269 28.68 10.7669 28.76 10.9269 28.76ZM3.68688 28.72C3.52688 28.88 3.56688 28.56 3.68688 28.72C3.56688 29 3.28688 28.96 3.24688 29.16C3.44688 29.04 3.72688 28.96 3.84688 28.68C3.72688 28.56 3.80688 28.68 3.68688 28.72ZM2.88687 28.88C2.88687 28.76 2.96687 28.88 3.00687 28.76C2.88687 28.76 2.96687 28.68 2.84687 28.68C2.84687 28.8 2.84687 28.88 2.88687 28.88ZM10.6069 28.88C10.6869 29 10.7669 29 10.8069 28.8C10.6869 28.8 10.6069 28.72 10.6069 28.88ZM2.64687 28.96C2.60687 28.96 2.60687 28.92 2.56687 28.92C2.44687 29.2 2.08687 29.12 1.96687 29.4C2.08687 29.28 2.16687 29.16 2.44687 29.16C2.44687 29.08 2.48687 29.04 2.52687 29C2.56687 29.04 2.60687 29.08 2.64687 29.08V28.96H2.76687C2.80687 28.84 2.52687 28.84 2.64687 28.96ZM10.9269 28.96C10.9669 28.96 11.0069 28.92 11.0069 28.88C10.9269 28.88 10.8869 28.92 10.9269 28.96ZM10.5269 29C10.4069 29.04 10.3669 28.96 10.3669 29.08C10.4869 29.08 10.5269 29.04 10.5269 29ZM10.7669 29.16H10.7269C10.6469 29.2 10.6069 29.24 10.5669 29.32C10.6869 29.44 10.7269 29.32 10.7269 29.16C10.7669 29.16 10.7669 29.16 10.7669 29.16C10.8869 29.12 10.7669 29.12 10.7669 29.16ZM10.5269 29.16C10.4869 29.2 10.4069 29.16 10.4069 29.2C10.4869 29.2 10.5269 29.2 10.5269 29.16ZM10.4869 29.56C10.3669 29.6 10.2469 29.6 10.2869 29.72C10.4469 29.76 10.4469 29.68 10.4869 29.56H10.5269C10.6069 29.48 10.6069 29.44 10.5269 29.4C10.4869 29.44 10.4469 29.52 10.4869 29.56ZM2.68687 29.6C2.76687 29.64 2.84687 29.6 2.88687 29.52C2.76687 29.52 2.80687 29.6 2.68687 29.6ZM9.92688 29.72C9.92688 29.64 9.88688 29.6 9.84688 29.6C9.84688 29.68 9.88688 29.72 9.92688 29.72ZM1.56687 29.64C1.60687 29.84 1.60687 29.52 1.56687 29.64V29.64ZM10.2469 29.8C10.1269 29.92 10.4069 29.68 10.2469 29.8V29.8ZM9.84688 30.24C9.76688 30.24 9.68688 30.28 9.64688 30.4C9.76688 30.36 9.84688 30.28 9.84688 30.24C9.96688 30.28 10.0869 30.08 9.96688 30.04C9.96688 30.16 9.80688 30.12 9.84688 30.24ZM9.28688 30.24C9.24688 30.28 9.20688 30.32 9.20688 30.28H9.24688C9.28688 30.28 9.28688 30.28 9.28688 30.24ZM2.24687 30.4C2.20687 30.4 2.16687 30.4 2.16687 30.44C2.20687 30.44 2.24687 30.44 2.24687 30.4ZM9.52688 30.6C9.56688 30.48 9.72688 30.44 9.56688 30.4C9.56688 30.44 9.36688 30.48 9.52688 30.6ZM8.96688 30.52C8.88688 30.52 8.84688 30.52 8.84688 30.56C8.88688 30.56 8.92687 30.56 8.96688 30.52ZM8.64688 30.6C8.76688 30.76 8.76688 30.44 8.64688 30.6V30.6ZM8.84688 30.64C8.72688 30.8 8.96688 30.52 8.84688 30.64V30.64ZM9.00688 31.04C9.12688 31 9.28688 30.84 9.44688 30.64C9.16688 30.68 9.12688 30.84 9.00688 31.04ZM8.60688 30.68V30.84C8.48688 30.84 8.56688 30.76 8.44688 30.8C8.40688 30.92 8.48688 30.92 8.64688 30.88C8.60688 30.84 8.72688 30.68 8.60688 30.68ZM9.92688 30.72V30.84C10.0469 30.88 10.0069 30.68 9.96688 30.68C9.96688 30.72 9.96688 30.76 9.92688 30.72ZM8.24688 30.88V31C8.12688 31 8.28688 31.2 8.24688 31C8.36688 30.96 8.28688 31.04 8.40688 31.04C8.40688 30.92 8.36688 30.88 8.24688 30.88ZM8.84688 31.16C8.92687 31.16 8.96688 31.12 8.96688 31.08H8.88688C8.84688 31.12 8.84688 31.16 8.84688 31.16ZM8.08688 31.16C8.12688 31.28 8.20688 31 8.08688 31.16V31.16ZM8.76688 31.2C8.64688 31.36 8.88688 31.08 8.76688 31.2V31.2ZM9.40688 31.16C9.36688 31.2 9.32688 31.2 9.32688 31.2C9.36688 31.2 9.36688 31.2 9.40688 31.16ZM7.76688 31.44C7.16688 31.56 6.64688 32.04 6.04688 32.32C6.20688 32.2 6.36688 32.44 6.40688 32.28C6.32688 32.28 6.28688 32.24 6.28688 32.16C6.72688 32.28 6.72688 31.84 6.88688 31.96C7.16688 31.52 7.48688 31.8 7.76688 31.44C7.80688 31.32 8.00688 31.44 7.96688 31.24C7.76688 31.2 7.72688 31.24 7.76688 31.44ZM8.56688 31.44C8.68688 31.32 8.76688 31.48 8.80688 31.36C8.76688 31.24 8.52688 31.16 8.56688 31.44ZM9.00688 31.44C9.16688 31.48 9.36688 31.44 9.20688 31.32C9.16688 31.44 8.96688 31.32 9.00688 31.44ZM8.72688 31.68C8.84688 31.64 8.92687 31.56 8.96688 31.44C8.84688 31.44 8.76688 31.52 8.72688 31.68ZM8.16688 31.64C8.04688 31.6 7.92688 31.76 8.04688 31.8C8.08688 31.68 8.20688 31.8 8.16688 31.64C8.20688 31.64 8.24688 31.6 8.24688 31.52C8.20688 31.52 8.16688 31.56 8.16688 31.64ZM8.60688 31.8L8.24688 31.88C8.36688 32 8.56688 31.92 8.60688 31.8ZM7.04688 32.2V32.4L7.32688 32.16C7.16688 32.12 7.16688 32.24 7.04688 32.2ZM7.72688 32.2V32.36C7.84688 32.48 7.84688 32.16 7.72688 32.2ZM5.04688 32.32C5.16688 32.52 5.16688 32.16 5.04688 32.32V32.32ZM6.88688 32.36C7.00688 32.56 7.00688 32.2 6.88688 32.36V32.36ZM4.80688 32.44C4.80688 32.4 4.72688 32.4 4.56688 32.4C4.44688 32.56 4.80688 32.56 4.80688 32.44ZM6.00688 32.4C5.96688 32.44 5.88688 32.4 5.88688 32.44C5.92688 32.44 5.96688 32.44 6.00688 32.4ZM6.72688 32.56H6.80688V32.4H6.68688C6.68688 32.48 6.68688 32.52 6.72688 32.56ZM5.64688 32.56C5.52688 32.56 5.48688 32.6 5.48688 32.72C5.64688 32.76 5.52688 32.6 5.64688 32.56C5.76688 32.56 5.80688 32.52 5.84688 32.44C5.72688 32.44 5.64688 32.48 5.64688 32.56ZM7.52688 32.56C7.64688 32.68 7.64688 32.4 7.52688 32.56V32.56ZM3.44688 32.8C3.48688 32.96 3.48688 33.2 3.64688 33.08C3.60688 33.08 3.56688 33.04 3.56688 32.96C3.84688 32.96 4.04688 33 4.16688 32.8C4.04688 32.8 4.00688 32.8 4.00688 32.76C4.12688 32.64 4.24688 32.76 4.36687 32.64C4.00688 32.52 3.72688 32.92 3.44688 32.8ZM4.48688 32.68H4.56688C4.68688 32.56 4.40688 32.52 4.40688 32.64C4.44688 32.68 4.48688 32.68 4.48688 32.68ZM6.52688 32.76C6.56688 32.64 6.68688 32.64 6.52688 32.6C6.56688 32.72 6.40688 32.72 6.52688 32.76ZM5.12688 32.72C5.08688 32.84 5.04688 32.92 5.04688 32.96C5.16688 32.84 5.32688 32.8 5.44688 32.68C5.28688 32.68 5.24688 32.72 5.12688 32.72C5.08688 32.68 5.00688 32.72 5.12688 32.72ZM6.28688 32.68V32.76C6.32688 32.76 6.36688 32.8 6.40688 32.8C6.36688 32.68 6.40688 32.68 6.28688 32.68ZM4.40688 32.72V32.8H4.48688V32.72H4.40688ZM6.84688 32.72V32.8H6.88688V32.72H6.84688ZM3.32688 32.84C2.84687 32.88 2.56687 32.88 2.40687 33.16C2.52687 33.16 2.52687 33.08 2.64687 33.08C2.68687 33.2 2.68687 33.08 2.64687 33.08C2.68687 32.96 3.00687 32.92 3.04688 33.08C2.92687 33.12 3.00687 33.04 2.88687 33.04C2.92687 33.32 3.32688 33.16 3.44688 33.04C3.40688 33 3.28688 33.08 3.28688 32.96C3.32688 32.96 3.32688 32.92 3.32688 32.84C3.44688 32.84 3.32688 32.8 3.32688 32.84ZM6.88688 32.92C6.88688 32.76 7.00688 33.08 6.88688 32.92V32.92ZM4.00688 33.24C4.28688 33.12 4.80688 33.24 4.92688 32.92C4.56688 33.04 4.20688 33.04 4.00688 33.24ZM3.44688 33.32C3.24688 33.2 3.28688 33.48 3.44688 33.32V33.32ZM3.72688 33.28C3.60688 33.28 3.52688 33.28 3.52688 33.32C3.64688 33.4 3.72688 33.4 3.72688 33.28ZM12.9669 24.4V24.28C13.0069 24.28 13.0469 24.32 13.0469 24.4H12.9669ZM12.9669 24.44C13.1269 24.44 13.0469 24.68 13.0869 24.72C13.0069 24.72 12.9669 24.64 12.9669 24.44ZM13.0869 24.88C12.9669 25.04 13.2469 24.76 13.0869 24.88V24.88ZM13.0469 25.76V25.12C13.2069 25.24 13.3269 25.72 13.0469 25.76ZM13.0469 26C13.0869 26.04 13.0869 26.08 13.0869 26.12C13.0869 26.16 13.0869 26.16 13.0469 26.2C12.9269 26.2 13.0469 26.04 13.0469 26ZM7.44688 26.56C7.32688 26.6 7.28688 26.68 7.16688 26.72C7.16688 26.56 7.32688 26.52 7.44688 26.56ZM9.56688 31.44C9.56688 31.44 9.56688 31.4 9.60688 31.36C9.56688 31.36 9.56688 31.4 9.56688 31.44Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function FontScriptIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 30 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.0967 16.32C29.0967 16.64 28.9234 17.0267 28.5767 17.48C28.1501 18.04 27.6301 18.48 27.0167 18.8C26.8034 18.9867 26.5767 19.0933 26.3367 19.12C25.8567 19.44 25.3901 19.6133 24.9367 19.64C24.7501 19.8267 24.4301 20 23.9767 20.16L23.2567 20.12L22.5367 20.72L21.7767 20.56L21.5367 20.6L20.9367 20.68C20.5367 20.7333 20.2034 20.76 19.9367 20.76C19.8834 20.76 19.7901 20.7467 19.6567 20.72C19.5234 20.72 19.4167 20.72 19.3367 20.72L18.7767 20.92L17.9767 21L17.0567 20.96L16.6167 21.16L16.7367 21.28C16.1234 21.28 15.6434 21.3333 15.2967 21.44L15.0967 21.4L13.4567 21.28L11.1367 21.2L10.3767 21.08C10.1367 21.1867 9.85672 21.24 9.53672 21.24C9.16339 21.24 8.77672 21.12 8.37672 20.88L7.61672 21.16L7.21672 20.8C6.09672 20.7733 5.44339 20.6667 5.25672 20.48L5.09672 20.4C5.17672 20.4 4.95005 20.4267 4.41672 20.48L2.85672 19.44L2.13672 19.28C1.68339 19.0667 1.29672 18.6933 0.976719 18.16C0.710052 17.7067 0.576719 17.2667 0.576719 16.84C0.576719 16.5467 0.710052 16.0267 0.976719 15.28L1.77672 14.4L2.73672 14.44C2.95005 14.1467 3.25672 14 3.65672 14C4.51005 14 4.93672 14.68 4.93672 16.04C4.37672 16.1733 4.04339 16.28 3.93672 16.36C3.80339 16.52 3.60339 16.6933 3.33672 16.88V17L3.69672 17.2L4.17672 17.72L5.73672 17.64L7.05672 18.04L9.13672 18L9.89672 18.48L10.2567 18.28C10.4167 18.28 10.6167 18.32 10.8567 18.4L11.8967 18.52L11.9767 18.72H12.6167C13.2301 18.5333 13.5767 18.44 13.6567 18.44C13.7901 18.44 13.9501 18.48 14.1367 18.56C14.3767 18.5067 14.6834 18.48 15.0567 18.48C15.3234 18.48 15.5634 18.5067 15.7767 18.56C15.9634 18.4533 16.1767 18.4 16.4167 18.4C16.7101 18.4 16.9634 18.4533 17.1767 18.56L18.0567 18.32L18.4967 17.84L20.0167 18C20.7901 17.76 21.4034 17.64 21.8567 17.64H22.0567C22.2434 17.5067 22.4034 17.44 22.5367 17.44C22.6167 17.44 22.7101 17.4667 22.8167 17.52C22.8167 17.52 22.9501 17.4667 23.2167 17.36V17.04H24.0567C24.2434 16.8 24.5767 16.6667 25.0567 16.64C25.4301 16.2933 25.7367 16.1067 25.9767 16.08C25.9767 16.08 26.0834 15.92 26.2967 15.6C26.2967 15.36 25.4434 14.84 23.7367 14.04L23.4167 13.8C22.8567 13.7467 22.4167 13.6533 22.0967 13.52C21.9101 13.52 21.7367 13.5067 21.5767 13.48H21.4967C21.3634 13.48 20.8434 13.32 19.9367 13C19.6434 12.7867 19.3367 12.68 19.0167 12.68C18.9101 12.68 18.7501 12.7067 18.5367 12.76H17.7367L17.6167 12.64C17.1901 12.56 16.8567 12.44 16.6167 12.28L16.1367 12.44L14.8967 11.84H14.0967L13.5767 11.52H12.7767L12.6567 11.32H12.0167L11.4567 10.68H11.1767C10.3501 10.68 9.71005 10.52 9.25672 10.2L9.17672 10.12C8.59005 9.93333 8.16339 9.64 7.89672 9.24L7.21672 8.6L6.77672 7.56L6.29672 6.92L6.49672 5.28L7.45672 4.16C7.61672 4.13333 7.73672 3.96 7.81672 3.64C7.89672 3.61333 8.03005 3.54667 8.21672 3.44L10.2567 2.32C10.5234 2.37333 10.7101 2.4 10.8167 2.4C11.1901 2.4 11.5767 2.26667 11.9767 2H12.2167V2.08L12.6167 1.72H12.8167C13.6701 1.4 14.3767 1.24 14.9367 1.24H15.1367L15.4967 1.28L16.0967 0.919999C16.2567 0.893332 16.4701 0.879999 16.7367 0.879999H16.9767C17.1634 0.879999 17.4834 0.853333 17.9367 0.8C18.4167 0.746666 18.7901 0.706666 19.0567 0.679999L19.7767 0.64L20.8567 0.0799999C20.9367 0.133333 21.1101 0.333332 21.3767 0.679999H22.2567C22.4167 0.679999 22.7101 0.759999 23.1367 0.919999H23.4167C24.0567 0.919999 24.5901 1.05333 25.0167 1.32C26.4301 1.66667 27.1367 2.37333 27.1367 3.44C27.1367 4.34667 26.4034 4.89333 24.9367 5.08L24.6167 4.6C24.5367 4.57333 24.3901 4.52 24.1767 4.44C23.9901 4.36 23.8434 4.30667 23.7367 4.28H22.8567L22.4567 3.84L21.8167 3.92L21.4567 4.32L20.4967 3.64L19.4567 3.8L18.2167 3.52C17.4434 3.57333 16.7901 3.73333 16.2567 4L16.1767 4.04C16.0967 4.09333 16.0034 4.14667 15.8967 4.2C15.8167 4.22667 15.7634 4.24 15.7367 4.24L15.1767 4L14.0567 4.52L11.9767 5.08L11.4967 4.96L10.6167 5.52H10.2167L9.97672 5.88L9.13672 6.44L9.21672 6.68C9.21672 6.68 9.36339 6.82667 9.65672 7.12L10.0567 7.24L10.6967 7.64L11.9367 8.08L12.5367 8.12L13.6167 8.76L13.9367 8.64C14.7101 8.8 15.2301 9.01333 15.4967 9.28L15.6167 9.4H15.6967C15.6967 9.4 15.9634 9.56 16.4967 9.88L16.7767 9.6L17.7367 9.64L17.8967 9.72H18.4567L19.0167 10.16H19.2967C19.7501 10.16 20.1501 10.2267 20.4967 10.36C20.5234 10.36 20.6567 10.3467 20.8967 10.32C21.3767 10.32 21.9101 10.5333 22.4967 10.96L22.9767 10.84L23.3367 11H24.0167L25.1767 11.8L26.3767 11.92L26.8567 12.56C27.7634 13.12 28.3501 13.6133 28.6167 14.04C28.9101 14.44 29.0567 15.0267 29.0567 15.8C29.0567 15.8533 29.0701 15.9333 29.0967 16.04C29.0967 16.1467 29.0967 16.24 29.0967 16.32Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function EraserIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.9995 13L10.9995 6.00004M20.9995 21H7.99955M10.9368 20.0628L19.6054 11.3941C20.7935 10.2061 21.3875 9.61207 21.6101 8.92709C21.8058 8.32456 21.8058 7.67551 21.6101 7.07298C21.3875 6.388 20.7935 5.79397 19.6054 4.60592L19.3937 4.39415C18.2056 3.2061 17.6116 2.61207 16.9266 2.38951C16.3241 2.19373 15.675 2.19373 15.0725 2.38951C14.3875 2.61207 13.7935 3.2061 12.6054 4.39415L4.39366 12.6059C3.20561 13.794 2.61158 14.388 2.38902 15.073C2.19324 15.6755 2.19324 16.3246 2.38902 16.9271C2.61158 17.6121 3.20561 18.2061 4.39366 19.3941L5.06229 20.0628C5.40819 20.4087 5.58114 20.5816 5.78298 20.7053C5.96192 20.815 6.15701 20.8958 6.36108 20.9448C6.59126 21 6.83585 21 7.32503 21H8.67406C9.16324 21 9.40784 21 9.63801 20.9448C9.84208 20.8958 10.0372 20.815 10.2161 20.7053C10.418 20.5816 10.5909 20.4087 10.9368 20.0628Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function HandIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.9 11.4444V14.2222M6.9 11.4444V4.77778C6.9 3.8573 7.66112 3.11111 8.6 3.11111C9.53888 3.11111 10.3 3.8573 10.3 4.77778M6.9 11.4444C6.9 10.524 6.13888 9.77778 5.2 9.77778C4.26112 9.77778 3.5 10.524 3.5 11.4444V13.6667C3.5 18.269 7.30558 22 12 22C16.6944 22 20.5 18.269 20.5 13.6667V8.11111C20.5 7.19064 19.7389 6.44444 18.8 6.44444C17.8611 6.44444 17.1 7.19064 17.1 8.11111M10.3 4.77778V10.8889M10.3 4.77778V3.66667C10.3 2.74619 11.0611 2 12 2C12.9389 2 13.7 2.74619 13.7 3.66667V4.77778M13.7 4.77778V10.8889M13.7 4.77778C13.7 3.8573 14.4611 3.11111 15.4 3.11111C16.3389 3.11111 17.1 3.8573 17.1 4.77778V8.11111M17.1 8.11111V10.8889"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function FrameIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V12M5 8V2M2 5H8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ZoomInIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 21L16.65 16.65M11 8V14M8 11H14M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ZoomOutIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 21L16.65 16.65M8 11H14M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function FlipBackwardIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 9H16.5C18.9853 9 21 11.0147 21 13.5C21 15.9853 18.9853 18 16.5 18H12M3 9L7 5M3 9L7 13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Share05Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 6H17.8C16.1198 6 15.2798 6 14.638 6.32698C14.0735 6.6146 13.6146 7.07354 13.327 7.63803C13 8.27976 13 9.11984 13 10.8V12M21 6L18 3M21 6L18 9M10 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function UploadCloud01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 16.2422C2.79401 15.435 2 14.0602 2 12.5C2 10.1564 3.79151 8.23129 6.07974 8.01937C6.54781 5.17213 9.02024 3 12 3C14.9798 3 17.4522 5.17213 17.9203 8.01937C20.2085 8.23129 22 10.1564 22 12.5C22 14.0602 21.206 15.435 20 16.2422M8 16L12 12M12 12L16 16M12 12V21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function BrushXLIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="10" fill="currentColor" />
    </svg>
  )
}

export function BrushSIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="4" fill="currentColor" />
    </svg>
  )
}

export function ArrowNarrowLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 12H4M4 12L10 18M4 12L10 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ArrowNarrowRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 12H20M20 12L14 6M20 12L14 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ArrowRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 12H19M19 12L12 5M19 12L12 19"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function UploadFailedIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 16.7428C21.2215 15.734 22 14.2079 22 12.5C22 9.46243 19.5376 7 16.5 7C16.2815 7 16.0771 6.886 15.9661 6.69774C14.6621 4.48484 12.2544 3 9.5 3C5.35786 3 2 6.35786 2 10.5C2 12.5661 2.83545 14.4371 4.18695 15.7935"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12L16 20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 12L8 20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Crop01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 6H14.8C15.9201 6 16.4802 6 16.908 6.21799C17.2843 6.40973 17.5903 6.71569 17.782 7.09202C18 7.51984 18 8.07989 18 9.2V22M22 18L9.2 18C8.07989 18 7.51984 18 7.09202 17.782C6.71569 17.5903 6.40973 17.2843 6.21799 16.908C6 16.4802 6 15.9201 6 14.8V2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CropCustomIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3 3H3.01M3 21H3.01M3 16.5H3.01M3 7.5H3.01M7.5 3H7.51M7.5 21H7.51M16.5 3H16.51M16.5 21H16.51M12 3H12.01M12 21H12.01M12 16.5H12.01M12 7.5H12.01M21 3H21.01M21 21H21.01M21 16.5H21.01M21 7.5H21.01M21 12H3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CropOriginalIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3"
        y="6"
        width="18"
        height="12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="2"
        y="5"
        width="2"
        height="2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="2"
        y="17"
        width="2"
        height="2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="20"
        y="5"
        width="2"
        height="2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="20"
        y="17"
        width="2"
        height="2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CropSquareIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CropCircleIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CropPortraitIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="5"
        y="3"
        width="14"
        height="18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CropLandscapeIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2"
        y="5"
        width="20"
        height="15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CropWideIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2"
        y="6"
        width="20"
        height="12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function OpacityTransparentIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15C5 8.5 12 2 12 2C12 2 19 8.5 19 15Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.28988 13C5.10128 13.6337 5 14.305 5 15C5 18.866 8.13401 22 12 22C15.866 22 19 18.866 19 15C19 14.305 18.8987 13.6337 18.7101 13H5.28988Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function GroupIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 2H14M22 10V14M18 22C18.93 22 19.395 22 19.7765 21.8978C20.8117 21.6204 21.6204 20.8117 21.8978 19.7765C22 19.395 22 18.93 22 18M22 6C22 5.07003 22 4.60504 21.8978 4.22354C21.6204 3.18827 20.8117 2.37962 19.7765 2.10222C19.395 2 18.93 2 18 2M6 2C5.07003 2 4.60504 2 4.22354 2.10222C3.18827 2.37962 2.37962 3.18827 2.10222 4.22354C2 4.60504 2 5.07003 2 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 22L10 22M2 14L2 10M2 18C2 18.93 2 19.395 2.10222 19.7765C2.37962 20.8117 3.18827 21.6204 4.22354 21.8978C4.60504 22 5.07003 22 6 22"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function UngroupIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2"
        y="2"
        width="13"
        height="13"
        rx="3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="9"
        y="9"
        width="13"
        height="13"
        rx="3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function DotsGridIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 6C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4C18.4477 4 18 4.44772 18 5C18 5.55228 18.4477 6 19 6Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 20C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18C18.4477 18 18 18.4477 18 19C18 19.5523 18.4477 20 19 20Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 6C5.55228 6 6 5.55228 6 5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 20C5.55228 20 6 19.5523 6 19C6 18.4477 5.55228 18 5 18C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function SunIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2V4M12 20V22M4 12H2M6.31412 6.31412L4.8999 4.8999M17.6859 6.31412L19.1001 4.8999M6.31412 17.69L4.8999 19.1042M17.6859 17.69L19.1001 19.1042M22 12H20M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Moon01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 15.8442C20.6866 16.4382 19.2286 16.7688 17.6935 16.7688C11.9153 16.7688 7.23116 12.0847 7.23116 6.30654C7.23116 4.77135 7.5618 3.3134 8.15577 2C4.52576 3.64163 2 7.2947 2 11.5377C2 17.3159 6.68414 22 12.4623 22C16.7053 22 20.3584 19.4742 22 15.8442Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Type01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 7C4.5 6.06812 4.5 5.60218 4.65224 5.23463C4.85523 4.74458 5.24458 4.35523 5.73463 4.15224C6.10218 4 6.56812 4 7.5 4H17.5C18.4319 4 18.8978 4 19.2654 4.15224C19.7554 4.35523 20.1448 4.74458 20.3478 5.23463C20.5 5.60218 20.5 6.06812 20.5 7M9.5 20H15.5M12.5 4V20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function TypeCapitalsIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 9.0625C1 8.42183 1 8.1015 1.10467 7.84881C1.24422 7.5119 1.5119 7.24422 1.84881 7.10467C2.1015 7 2.42183 7 3.0625 7H9.9375C10.5782 7 10.8985 7 11.1512 7.10467C11.4881 7.24422 11.7558 7.5119 11.8953 7.84881C12 8.1015 12 8.42183 12 9.0625M4.4375 18H8.5625M6.5 7V18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9.0625C12 8.42183 12 8.1015 12.1047 7.84881C12.2442 7.5119 12.5119 7.24422 12.8488 7.10467C13.1015 7 13.4218 7 14.0625 7H20.9375C21.5782 7 21.8985 7 22.1512 7.10467C22.4881 7.24422 22.7558 7.5119 22.8953 7.84881C23 8.1015 23 8.42183 23 9.0625M15.4375 18H19.5625M17.5 7V18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function TransformationCircleIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.6899 9.13132C24.3839 8.5463 24.2639 7.91328 24.3329 7.23225C24.4019 6.55122 24.6689 5.8492 25.1339 5.12917C25.599 4.40314 26.127 3.87213 26.721 3.53011C27.315 3.1881 27.9391 3.03809 28.5991 3.0771C29.2591 3.1161 29.9161 3.35011 30.5731 3.77312C31.1522 4.14814 31.5902 4.58915 31.8872 5.10217C32.1842 5.61519 32.3342 6.14921 32.3372 6.70723C32.3372 7.26525 32.1902 7.79627 31.8902 8.30629L31.8692 8.35129L30.2401 7.30125L30.2731 7.23225C30.3871 6.97424 30.4411 6.72223 30.4411 6.47022C30.4411 6.22121 30.3781 5.9842 30.2521 5.7592C30.1261 5.53419 29.9341 5.33918 29.6731 5.17117C29.3671 4.97317 29.0491 4.88316 28.7191 4.90116C28.3891 4.91916 28.0651 5.03917 27.747 5.26118C27.429 5.48318 27.135 5.8072 26.862 6.23021V6.23621C26.583 6.66223 26.409 7.06724 26.334 7.45426C26.259 7.84127 26.283 8.18629 26.406 8.4953C26.529 8.80431 26.742 9.05632 27.048 9.25432C27.294 9.41333 27.543 9.50333 27.795 9.53034C28.0471 9.55734 28.2931 9.51833 28.5301 9.41933C28.7671 9.32033 28.9861 9.15832 29.1871 8.93631L29.2261 8.89731L30.8492 9.94435L30.8162 9.99535C30.4771 10.4754 30.0511 10.8264 29.5411 11.0514C29.0311 11.2764 28.4791 11.3574 27.891 11.3004C27.303 11.2434 26.718 11.0274 26.142 10.6554C25.479 10.2294 24.9959 9.72234 24.6869 9.14032L24.6899 9.13132ZM30.0931 14.6845L36.6754 10.3254L35.5653 8.6513L28.9831 13.0105L30.0931 14.6845ZM39.0845 18.4707C38.9705 18.9477 38.7455 19.3377 38.4064 19.6407C38.0674 19.9467 37.6264 20.1507 37.0774 20.2587H37.0654C36.5674 20.3577 36.0964 20.3277 35.6523 20.1657C35.2083 20.0037 34.8573 19.7397 34.5993 19.3737L31.9472 21.5038L31.5092 19.2867L33.9153 17.4356C33.9153 17.4356 33.9093 17.4116 33.9063 17.3966C33.9033 17.3816 33.9003 17.3636 33.8973 17.3456L33.7173 16.4336L31.0502 16.9586L30.6632 14.9875L38.4094 13.4605L39.0695 16.8146C39.1925 17.4416 39.1985 17.9906 39.0845 18.4677V18.4707ZM37.5394 16.8806L37.3114 15.7256L35.1483 16.1516L35.3793 17.3156C35.4483 17.6666 35.6013 17.9246 35.8353 18.0927C36.0724 18.2607 36.3514 18.3117 36.6784 18.2487H36.6904C37.0174 18.1827 37.2574 18.0237 37.4104 17.7746C37.5634 17.5256 37.6084 17.2256 37.5394 16.8776V16.8806ZM37.5874 23.8709C37.1344 23.3578 36.5104 22.9438 35.7123 22.6288H35.7063C34.9083 22.3138 34.1673 22.1908 33.4863 22.2568C32.8052 22.3228 32.2052 22.5658 31.6952 22.9828C31.1822 23.3999 30.7832 23.9729 30.4951 24.7079C30.2461 25.3469 30.1501 25.9589 30.2071 26.55C30.2671 27.138 30.4561 27.663 30.7772 28.119C31.0982 28.575 31.5272 28.9231 32.0642 29.1631L32.1212 29.1841L32.8262 27.387L32.7782 27.357C32.5202 27.204 32.3192 27.021 32.1722 26.808C32.0282 26.595 31.9412 26.361 31.9172 26.1089C31.8932 25.8569 31.9352 25.5929 32.0402 25.3229C32.1722 24.9839 32.3792 24.7229 32.6582 24.5429C32.9372 24.3629 33.2732 24.2699 33.6663 24.2669C34.0593 24.2669 34.4913 24.3539 34.9623 24.5399H34.9683C35.4363 24.7259 35.8113 24.9509 36.0933 25.2179C36.3754 25.4849 36.5554 25.7789 36.6394 26.1C36.7234 26.421 36.6964 26.751 36.5614 27.09C36.4474 27.378 36.2944 27.606 36.0994 27.774C35.9044 27.939 35.6853 28.05 35.4393 28.101C35.1933 28.152 34.9353 28.146 34.6593 28.086L34.5843 28.068L33.8763 29.8711L33.9243 29.8831C34.4823 30.0781 35.0343 30.1201 35.5803 30.0061C36.1264 29.8921 36.6214 29.6401 37.0654 29.2471C37.5094 28.8541 37.8574 28.338 38.1094 27.696C38.3974 26.967 38.4934 26.274 38.4034 25.6229C38.3134 24.9689 38.0404 24.3869 37.5874 23.8709ZM24.8969 31.2451L25.905 32.5082L28.4581 30.4711L32.3762 35.3793L33.9453 34.1282L29.0191 27.957L24.8969 31.2481V31.2451ZM19.4787 32.3882L19.8087 33.9692L23.1389 33.2732L23.4659 34.8363L20.3338 35.4933L20.6428 36.9724L23.7749 36.3153L24.0929 37.8424L20.7628 38.5384L21.0928 40.1195L26.391 39.0124L24.7739 31.2841L19.4787 32.3912V32.3882ZM12.6205 29.4901C12.0745 29.0761 11.5104 28.8181 10.9254 28.713C10.3404 28.608 9.78838 28.65 9.26036 28.8361C8.73534 29.0221 8.28233 29.3401 7.90731 29.7901L7.87131 29.8381L9.41037 31.0051L9.45237 30.9691C9.66838 30.7621 9.89938 30.6181 10.1454 30.5371C10.3914 30.4561 10.6374 30.4381 10.8864 30.4831C11.1354 30.5281 11.3784 30.6391 11.6094 30.8161C11.9005 31.0351 12.0955 31.3051 12.1915 31.6232C12.2905 31.9412 12.2875 32.2892 12.1825 32.6672C12.0775 33.0452 11.8735 33.4382 11.5674 33.8402H11.5644C11.2614 34.2453 10.9404 34.5453 10.6074 34.7433C10.2744 34.9413 9.94139 35.0373 9.61137 35.0283C9.28136 35.0193 8.96935 34.9053 8.67834 34.6863C8.43233 34.5003 8.25532 34.2903 8.14732 34.0562C8.03931 33.8222 7.99431 33.5822 8.01231 33.3332C8.03031 33.0842 8.10532 32.8352 8.23732 32.5862L8.27632 32.5172L6.73427 31.3471L6.71027 31.3891C6.37125 31.8722 6.18225 32.3942 6.14325 32.9492C6.10424 33.5042 6.21225 34.0502 6.47026 34.5843C6.72827 35.1183 7.13028 35.5923 7.6793 36.0093C8.30332 36.4833 8.94235 36.7653 9.59637 36.8554C10.2504 36.9454 10.8834 36.8433 11.5014 36.5463C12.1195 36.2493 12.6865 35.7603 13.2055 35.0793H13.2085C13.7275 34.3923 14.0455 33.7112 14.1655 33.0362C14.2855 32.3612 14.2165 31.7192 13.9525 31.1131C13.6915 30.5071 13.2475 29.9671 12.6175 29.4901H12.6205ZM8.99335 25.1699L2.09609 29.0161L3.07413 30.7711L9.96839 26.925L8.99035 25.1699H8.99335ZM8.44133 24.8249L0.599041 25.7369L0.203024 22.3408C0.128021 21.7078 0.167022 21.1558 0.320028 20.6908C0.473033 20.2257 0.728042 19.8537 1.08806 19.5777C1.44807 19.3017 1.90709 19.1307 2.46211 19.0647H2.47411C2.97813 19.0047 3.44615 19.0737 3.87516 19.2687C4.30418 19.4637 4.63419 19.7547 4.8622 20.1387L7.6733 18.2247L7.93431 20.4687L5.39021 22.1248C5.39021 22.1248 5.39022 22.1488 5.39622 22.1668C5.39622 22.1818 5.39922 22.1998 5.40222 22.2178L5.51022 23.1418L8.21032 22.8268L8.44133 24.8219V24.8249ZM4.06117 23.3128L3.92316 22.1338C3.88116 21.7798 3.74916 21.5098 3.52715 21.3238C3.30514 21.1378 3.02913 21.0658 2.69912 21.1018H2.68712C2.3571 21.1408 2.10509 21.2788 1.93109 21.5158C1.75708 21.7528 1.69108 22.0468 1.73008 22.3978L1.86508 23.5649L4.05517 23.3098L4.06117 23.3128ZM2.2191 15.4376C2.63011 15.9866 3.22114 16.4456 3.99516 16.8176H4.00117C4.77219 17.1926 5.50122 17.3726 6.18824 17.3576C6.87527 17.3426 7.48729 17.1476 8.03031 16.7726C8.57333 16.3976 9.01435 15.8546 9.35936 15.1435C9.65938 14.5255 9.80038 13.9225 9.78838 13.3285C9.77638 12.7345 9.62638 12.2004 9.34136 11.7204C9.05635 11.2404 8.65434 10.8624 8.13832 10.5834L8.08432 10.5564L7.24429 12.2934L7.28929 12.3264C7.53529 12.4974 7.7213 12.6955 7.85031 12.9205C7.97931 13.1455 8.04532 13.3825 8.05132 13.6375C8.05732 13.8925 7.99431 14.1505 7.86831 14.4115C7.7093 14.7385 7.48429 14.9845 7.19328 15.1435C6.90227 15.3025 6.56026 15.3686 6.16725 15.3416C5.77423 15.3145 5.35121 15.1885 4.8952 14.9695H4.8892C4.43618 14.7475 4.07917 14.4955 3.82116 14.2075C3.56315 13.9195 3.40114 13.6135 3.34414 13.2865C3.28714 12.9625 3.33814 12.6354 3.49714 12.3054C3.63215 12.0264 3.80316 11.8104 4.01017 11.6604C4.21717 11.5104 4.44518 11.4174 4.69419 11.3844C4.9432 11.3514 5.20121 11.3784 5.46822 11.4594L5.54322 11.4834L6.38625 9.74034L6.33825 9.72234C5.79823 9.48533 5.24921 9.40133 4.69719 9.47333C4.14517 9.54534 3.63215 9.75834 3.15814 10.1154C2.68412 10.4724 2.3001 10.9614 2.00009 11.5824C1.65808 12.2874 1.50807 12.9715 1.55008 13.6285C1.59208 14.2855 1.81708 14.8885 2.2281 15.4376H2.2191ZM11.8315 9.55134L8.29732 4.35814L6.63826 5.48918L11.0814 12.0174L15.4406 9.05032L14.5316 7.71527L11.8315 9.55434V9.55134ZM20.7178 6.73123L17.3427 7.16625L17.1387 5.58219L20.3128 5.17417L20.1208 3.67712L16.9466 4.08513L16.7486 2.53708L20.1238 2.10206L19.9168 0.5L14.5496 1.19003L15.5576 9.02032L20.9248 8.33029L20.7178 6.72823V6.73123Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function TransformationFlagIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 40 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.49455 9.68046C8.49455 10.4461 8.49455 11.216 8.49455 11.9816C6.89485 11.879 5.29516 11.3272 3.69547 10.1552V12.7216C5.14973 13.7866 6.604 14.3384 8.05399 14.5052C8.05399 15.2366 8.05399 15.968 8.05399 16.6952C6.59972 16.5241 5.14546 15.9766 3.69547 14.9115V19.1075C2.74164 18.4103 1.78781 17.4864 0.833984 16.3059V5.04819C3.3875 8.20908 5.94103 9.50936 8.49455 9.67618V9.68046ZM12.6307 9.07736C11.6768 9.3896 10.723 9.60347 9.76917 9.6719C9.76917 13.4231 9.76917 17.1742 9.76917 20.9296C12.2756 20.7457 14.7821 19.5866 17.2886 18.1494V15.8483C15.7359 16.7379 14.1833 17.5207 12.6307 18.0339C12.6307 15.0484 12.6307 12.0629 12.6307 9.07736ZM25.2742 2.19098C26.536 5.31338 27.8021 8.54698 29.0639 11.9902C28.0587 12.2383 27.0578 12.6146 26.0527 13.0766C25.8174 12.3623 25.5822 11.6566 25.3469 10.9508C24.1236 11.5582 22.9046 12.2682 21.6813 13.0167C21.4461 13.9834 21.2151 14.9458 20.9798 15.9124C19.9747 16.5326 18.9738 17.1614 17.9687 17.7559C19.2305 13.2562 20.4965 8.70097 21.7583 4.17991C22.3528 3.82062 22.9431 3.46988 23.5376 3.13626V3.1277C23.8199 2.96944 24.1022 2.81119 24.3845 2.66148C24.3888 2.66148 24.3931 2.6572 24.3974 2.65293C24.6882 2.49467 24.9791 2.34497 25.2699 2.19954L25.2742 2.19098ZM24.7609 9.18001C24.3546 7.96955 23.9483 6.76765 23.5419 5.57002C23.5248 5.57857 23.5034 5.5914 23.4863 5.59996C23.08 7.25525 22.6779 8.91911 22.2716 10.5872C23.1014 10.0868 23.9312 9.61202 24.7609 9.17574V9.18001ZM34.821 6.12606V8.15348C35.5696 8.45716 36.3181 8.88061 37.0666 9.44093C37.0623 9.4837 37.058 9.52647 37.0495 9.56925C37.0238 9.92426 36.9126 10.1638 36.7159 10.3007C36.5191 10.4375 36.2539 10.476 35.9246 10.4375C35.5952 10.399 35.2146 10.2793 34.7825 10.1082C34.2351 9.89004 33.7603 9.62057 33.3539 9.26128C32.9476 8.90199 32.6354 8.46571 32.413 7.91823C32.1905 7.37501 32.0836 6.73771 32.0836 5.99774V5.98919C32.0836 5.26205 32.1863 4.64613 32.3916 4.15852C32.5969 3.67092 32.892 3.32018 33.277 3.13198C33.6619 2.94806 34.1239 2.93523 34.6585 3.14053C35.2103 3.35012 35.6765 3.72224 36.0572 4.20557C36.4378 4.6889 36.703 5.23211 36.8485 5.78388C36.857 5.8181 36.8698 5.85231 36.8784 5.88653C37.8237 6.56661 38.7647 7.46056 39.7099 8.60686C39.7057 8.56837 39.7014 8.52988 39.6928 8.49566C39.5987 7.65732 39.325 6.66927 38.8759 5.61279C38.4225 4.5563 37.8365 3.53404 37.1137 2.6572C36.3908 1.78037 35.5696 1.12167 34.65 0.770938C33.5165 0.338936 32.5413 0.454423 31.72 0.899257C30.8988 1.34837 30.27 2.10544 29.8252 3.04643C29.3804 3.99171 29.158 5.09524 29.158 6.31426V6.32281C29.158 7.55894 29.3804 8.54698 29.8295 9.33828C30.2786 10.1296 30.9159 10.7027 31.7457 11.1775C32.5755 11.6566 33.5678 12.0073 34.7312 12.4607C35.8005 12.8841 36.7201 13.2862 37.4815 13.5086C38.2428 13.731 38.8246 13.7781 39.2309 13.4872C39.6329 13.2006 39.834 12.5804 39.834 11.5539V10.1424C38.1659 8.07648 36.4935 6.80614 34.8253 6.12606H34.821Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function TransformationAngleIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 40 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.31625 7.55761L1.98191 7.82578L0.833984 16.8358L3.0906 16.3845L3.2443 14.4321L5.99148 13.8794L6.89085 15.6225L9.14745 15.1679L4.61135 7.29924L3.31298 7.56088L3.31625 7.55761ZM3.37512 12.7903L3.64329 9.40214L3.68581 9.39233L5.24254 12.4142L3.37512 12.7903ZM15.6295 5.07862L17.3301 13.5163L15.5281 13.8794L11.149 9.64415L11.1097 9.65069L12.1007 14.5694L9.95525 15.0011L8.25461 6.56339L10.0795 6.19711L14.4325 10.3833L14.4685 10.3767L13.4873 5.51359L15.6262 5.08188L15.6295 5.07862ZM25.6566 8.11685C25.8136 8.88541 25.794 9.57547 25.6043 10.1936C25.4146 10.8084 25.0647 11.3252 24.5545 11.7405C24.0443 12.1558 23.3869 12.4469 22.5857 12.6072C21.7157 12.7838 20.9374 12.7609 20.2441 12.5385C19.5507 12.3194 18.9718 11.9138 18.5042 11.3284C18.0365 10.743 17.7095 9.99082 17.523 9.06528V9.05874C17.3366 8.14302 17.3432 7.32868 17.5459 6.61245C17.7487 5.89623 18.1215 5.30755 18.6644 4.8366C19.2073 4.36893 19.9039 4.04515 20.7542 3.87509C21.4443 3.73446 22.0853 3.73446 22.6773 3.87509C23.2692 4.01572 23.7794 4.26101 24.2046 4.62403C24.6297 4.98704 24.9339 5.43182 25.1137 5.9649L25.1399 6.03358L23.0174 6.46528L22.9814 6.40968C22.8048 6.09245 22.553 5.86679 22.2259 5.7327C21.8989 5.59862 21.5326 5.57245 21.1173 5.65748C20.715 5.73924 20.3912 5.90604 20.1427 6.16113C19.8941 6.41623 19.7306 6.74981 19.6554 7.16188C19.5769 7.57396 19.5965 8.05144 19.7044 8.59761V8.60415C19.8189 9.15685 19.9955 9.61472 20.2408 9.97447C20.4861 10.3342 20.7804 10.586 21.1271 10.7332C21.4737 10.8771 21.8498 10.9098 22.2586 10.8281C22.5824 10.7626 22.8571 10.6482 23.0795 10.4879C23.3052 10.3277 23.4687 10.1282 23.5766 9.8927C23.6813 9.65723 23.7173 9.3956 23.6813 9.11107L23.6715 9.00314L21.9872 9.34327L21.6798 7.82252L25.4342 7.0605L25.6501 8.11685H25.6566ZM32.7208 8.59434L33.0707 10.3179L27.4357 11.4658L25.7155 3.03132L27.8609 2.59308L29.228 9.30075L32.7175 8.59107L32.7208 8.59434ZM39.834 8.93119L34.0551 10.1184L32.3251 1.68717L38.1039 0.5L38.4571 2.22352L34.8237 2.96918L35.1638 4.63384L38.5814 3.93396L38.9117 5.54629L35.4941 6.24616L35.8441 7.95333L39.4775 7.20767L39.8307 8.93119H39.834Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function TransformationArcLowerIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 40 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9704 7.31017C19.3513 7.31322 19.5433 7.31627 19.9241 7.31627C19.9424 7.31627 19.9607 7.31627 19.9759 7.31627C19.9942 7.31627 20.0064 7.31627 20.0186 7.31627C20.5732 8.71489 20.8505 9.41268 21.4081 10.8022C22.3375 10.79 22.8037 10.7808 23.733 10.7443C23.0779 9.22986 22.7519 8.46503 22.1028 6.92624C22.5203 6.68856 22.8524 6.30463 23.1023 5.78357C23.3491 5.26252 23.474 4.67747 23.471 4.03148C23.471 4.02539 23.471 4.02234 23.471 4.01625C23.471 3.30322 23.3461 2.69989 23.1084 2.20321C22.8677 1.70653 22.5233 1.32565 22.0693 1.06359C21.6153 0.801542 21.0668 0.670516 20.4178 0.670516C19.0283 0.670516 18.3336 0.670516 16.9441 0.670516C16.9288 4.02843 16.9166 7.38331 16.9014 10.7412C17.7272 10.7717 18.1416 10.7839 18.9674 10.7961C18.9674 9.40049 18.9704 8.70271 18.9734 7.31017H18.9704ZM18.9795 2.61762C19.4579 2.61762 19.6987 2.61762 20.1771 2.61762C20.5366 2.61762 20.8261 2.7456 21.0455 3.0046C21.2649 3.26056 21.3746 3.60184 21.3746 4.02843C21.3746 4.03453 21.3746 4.03758 21.3746 4.04367C21.3746 4.47027 21.2679 4.81154 21.0546 5.0675C20.8413 5.32346 20.5518 5.45144 20.1862 5.45144C19.7017 5.45144 19.4579 5.45144 18.9734 5.44534C18.9734 4.31486 18.9734 3.7481 18.9795 2.61762ZM10.8437 8.19688C11.7792 8.27916 12.5288 8.33096 13.4673 8.38581C13.6136 9.04703 13.772 9.76005 13.9549 10.5828C14.8202 10.6437 15.2529 10.6681 16.1213 10.7108C15.2407 7.36502 14.3571 4.01625 13.4704 0.670516C13.2205 0.670516 13.0346 0.670516 12.8487 0.670516C12.0961 0.670516 11.7213 0.670516 10.9687 0.667469C10.0545 3.77857 9.14041 6.88967 8.17143 9.98554C9.02767 10.1013 9.45731 10.1562 10.3166 10.2537C10.5116 9.48886 10.6823 8.82154 10.8377 8.19993L10.8437 8.19688ZM12.221 2.79435C12.5562 4.28439 12.8091 5.41792 13.062 6.55144C12.4374 6.52097 11.9072 6.49355 11.2825 6.45394C11.5537 5.37221 11.8249 4.26306 12.1814 2.79435C12.1967 2.79435 12.2058 2.79435 12.221 2.79435ZM2.78413 17.2986C4.06392 17.8105 4.70991 18.0452 6.01712 18.4596C6.01103 19.197 6.00493 19.5657 5.99884 20.3031C3.89024 19.5626 2.85422 19.1238 0.833984 18.103V10.083C1.62319 10.2933 2.02236 10.3939 2.8207 10.5858C2.80547 13.2703 2.79937 14.6141 2.78413 17.2986ZM12.5318 12.6609C11.9377 12.1856 11.2307 11.9052 10.4141 11.8016C9.60662 11.698 8.90578 11.7986 8.3116 12.0941C7.71741 12.3897 7.25425 12.8529 6.92516 13.4928C6.59607 14.1296 6.42848 14.9219 6.41934 15.8878C6.41934 15.8939 6.41934 15.8939 6.41934 15.9C6.4102 16.8659 6.55951 17.7435 6.87336 18.5449C7.18417 19.3463 7.63209 20.0349 8.22018 20.5986C8.80828 21.1593 9.50606 21.5554 10.3196 21.7504C11.1454 21.9485 11.8584 21.8906 12.4618 21.5889C13.0651 21.2842 13.5344 20.7662 13.8665 20.0441C14.1986 19.3219 14.3662 18.426 14.3754 17.3687C14.3754 17.3626 14.3754 17.3596 14.3754 17.3565C14.3814 16.2992 14.226 15.3698 13.9061 14.5745C13.5861 13.7792 13.1291 13.1454 12.5349 12.67L12.5318 12.6609ZM12.2637 17.0914C12.2576 17.7008 12.1784 18.2219 12.0199 18.6424C11.8615 19.0659 11.6421 19.3737 11.3557 19.5657C11.0723 19.7546 10.731 19.8094 10.3349 19.7241C9.95399 19.6418 9.6249 19.4438 9.34457 19.1421C9.06423 18.8405 8.85094 18.4504 8.70163 17.9842C8.55232 17.515 8.48224 16.9878 8.48833 16.3997C8.48833 16.3936 8.48833 16.3906 8.48833 16.3875C8.49442 15.7933 8.5767 15.2997 8.73515 14.9005C8.8936 14.5014 9.11604 14.2088 9.40246 14.023C9.68889 13.8371 10.018 13.7701 10.3958 13.8279C10.7828 13.8858 11.118 14.0534 11.3983 14.3338C11.6787 14.6141 11.895 14.9889 12.0474 15.4582C12.1997 15.9274 12.2728 16.4698 12.2668 17.0823C12.2668 17.0884 12.2668 17.0914 12.2668 17.0945L12.2637 17.0914ZM32.1309 19.1848C32.14 19.9526 32.1431 20.3366 32.1522 21.1045C29.9583 21.7261 28.843 21.9637 26.6004 22.2928C26.576 18.9837 26.5516 15.6745 26.5272 12.3684C28.7486 12.1886 29.8577 12.0606 32.0547 11.7224C32.0638 12.4903 32.0669 12.8742 32.076 13.6421C30.6957 13.8919 30.0009 13.9986 28.6054 14.1723C28.6115 14.9432 28.6145 15.3302 28.6237 16.1011C29.937 15.9122 30.5921 15.7994 31.8902 15.5374C31.8963 16.2565 31.9023 16.6161 31.9084 17.3382C30.6073 17.6338 29.9552 17.7587 28.6389 17.969C28.645 18.7582 28.648 19.1543 28.6572 19.9435C30.0558 19.6936 30.7536 19.5443 32.1339 19.1878L32.1309 19.1848ZM38.2982 15.6471C38.6974 15.3058 39.0143 14.8762 39.252 14.3673C39.4897 13.8615 39.6085 13.3526 39.6085 12.8346V12.8224C39.6085 12.2526 39.4927 11.8047 39.2642 11.4695C39.0326 11.1343 38.6974 10.9149 38.2556 10.8113C37.8137 10.7077 37.2744 10.7199 36.6376 10.8601C35.2724 11.1587 34.5838 11.2928 33.2004 11.5304C33.2309 14.608 33.2644 17.6825 33.2949 20.7601C34.1054 20.5072 34.5076 20.3701 35.306 20.0745C35.2938 18.8465 35.2877 18.231 35.2785 17.003C35.6503 16.8873 35.8362 16.8294 36.2049 16.7075C36.2232 16.7014 36.2414 16.6953 36.2567 16.6892C36.2719 16.6831 36.2871 16.68 36.2963 16.677C36.8417 17.7008 37.1129 18.1945 37.6492 19.133C38.5329 18.746 38.9686 18.5418 39.834 18.103C39.2307 17.1828 38.9229 16.6892 38.3013 15.644L38.2982 15.6471ZM37.2866 14.4313C37.0794 14.7116 36.8021 14.9097 36.4456 15.0163C35.9733 15.1595 35.7387 15.2296 35.2633 15.3606C35.2542 14.3642 35.2511 13.8676 35.242 12.8712C35.7143 12.7615 35.9489 12.7066 36.4182 12.5878C36.7716 12.4994 37.055 12.536 37.2683 12.6944C37.4847 12.8529 37.5913 13.1088 37.5944 13.4653C37.5944 13.4714 37.5944 13.4714 37.5944 13.4775C37.5944 13.834 37.4938 14.1509 37.2896 14.4313H37.2866ZM23.5502 12.5482C24.4034 12.5116 24.833 12.4903 25.6832 12.4293C24.9915 15.8269 24.2967 19.2274 23.602 22.625C22.7793 22.6859 22.3649 22.7072 21.5422 22.7316C21.0181 20.3183 20.756 19.1055 20.241 16.674C20.2258 16.674 20.2167 16.674 20.2014 16.674C19.6834 19.1025 19.4214 20.3153 18.8973 22.7255C18.0684 22.6981 17.6571 22.6737 16.8313 22.6067C16.1366 19.2092 15.4418 15.8116 14.7532 12.4141C15.6064 12.475 16.036 12.5025 16.8923 12.539C17.3219 15.2174 17.5352 16.5643 17.9709 19.2518C17.9862 19.2518 17.9953 19.2518 18.0106 19.2518C18.5499 16.6069 18.818 15.2753 19.3513 12.6061C20.0491 12.6152 20.3965 12.6152 21.0942 12.6061C21.6214 15.2784 21.8895 16.61 22.4258 19.2579C22.4411 19.2579 22.4502 19.2579 22.4654 19.2579C22.9042 16.5673 23.1206 15.2235 23.5533 12.5421L23.5502 12.5482ZM26.1463 10.1897C25.5552 9.81795 25.0951 9.24509 24.7721 8.48331C24.4491 7.71849 24.2846 6.78912 24.2785 5.69825C24.2785 5.69825 24.2785 5.69521 24.2785 5.69216C24.2724 4.60129 24.4278 3.66583 24.7447 2.88881C25.0585 2.1118 25.5095 1.51761 26.0885 1.1093C26.6674 0.700987 27.3591 0.499878 28.1544 0.499878C28.8552 0.499878 29.4738 0.667469 30.0131 0.99351C30.5525 1.31955 30.9791 1.75834 31.2929 2.31291C31.6068 2.86444 31.7805 3.4891 31.8109 4.18993C31.8109 4.21431 31.814 4.22345 31.817 4.24783C31.0309 4.28744 30.6378 4.30572 29.8486 4.33924C29.8425 4.30267 29.8425 4.28439 29.8364 4.24783C29.7877 3.91264 29.6932 3.61707 29.553 3.36416C29.4129 3.11125 29.2239 2.91319 28.9923 2.76998C28.7608 2.62676 28.4865 2.55668 28.1727 2.56277C27.8009 2.56887 27.481 2.69685 27.2098 2.94062C26.9386 3.18743 26.7314 3.53785 26.5851 3.99492C26.4389 4.44894 26.3688 4.99437 26.3749 5.62817C26.3749 5.62817 26.3749 5.63122 26.3749 5.63426C26.3779 6.27111 26.4572 6.81654 26.6095 7.26752C26.7619 7.71849 26.9782 8.05672 27.2555 8.2822C27.5328 8.50769 27.8588 8.6052 28.2306 8.57777C28.5292 8.55644 28.7912 8.46503 29.0228 8.30658C29.2544 8.14813 29.4403 7.93179 29.5865 7.65755C29.7328 7.38635 29.8273 7.06641 29.873 6.7038C29.876 6.67638 29.8791 6.66419 29.8821 6.63676C30.6683 6.58496 31.0613 6.55449 31.8475 6.4905C31.8475 6.51793 31.8475 6.53316 31.8475 6.56363C31.8292 7.26447 31.6647 7.90741 31.3569 8.49855C31.0492 9.08969 30.6286 9.57723 30.0954 9.96421C29.5622 10.3481 28.9436 10.5797 28.2428 10.6437C27.4383 10.7168 26.7375 10.5645 26.1463 10.1927V10.1897Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function TransformationArcUpperIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 40 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1904 9.35015C12.3618 10.0259 12.543 10.7576 12.754 11.6014C13.6901 11.5157 14.1615 11.4828 15.1009 11.4267C14.1087 8.00533 13.11 4.58393 12.0651 1.17571C11.6498 1.24823 11.3927 1.29767 11.0532 1.36689C10.4335 1.49214 10.0314 1.58114 9.3293 1.75254C8.39979 5.31237 7.46038 8.86892 6.5078 12.4222C7.43072 12.2607 7.89548 12.1881 8.82499 12.0563C9.01946 11.1927 9.19087 10.4412 9.34579 9.7391C10.3577 9.571 11.1685 9.45893 12.1904 9.35015ZM10.7335 3.69397C11.1257 5.19371 11.4224 6.33748 11.719 7.48454C11.0367 7.57353 10.4632 7.66253 9.78747 7.78448C10.0578 6.5748 10.3313 5.33545 10.6939 3.70056C10.7104 3.70056 10.7203 3.69397 10.7368 3.69397H10.7335ZM18.1762 7.59331C18.5915 7.58342 18.8024 7.58012 19.2177 7.57683C19.2375 7.57683 19.2573 7.57683 19.2771 7.57683C19.2968 7.57683 19.31 7.57683 19.3232 7.57683C19.9297 9.06009 20.233 9.80502 20.8328 11.3015C21.8415 11.318 22.3458 11.3311 23.3511 11.3806C22.6556 9.70943 22.3062 8.87221 21.6041 7.20436C22.0623 6.97034 22.4282 6.58798 22.7051 6.05071C22.9819 5.51344 23.1204 4.90695 23.1237 4.21805C23.1237 4.21146 23.1237 4.20817 23.1237 4.20157C23.1237 3.44346 22.9984 2.79082 22.738 2.24037C22.4776 1.69321 22.0953 1.26141 21.5943 0.961461C21.0932 0.661511 20.4802 0.503296 19.7583 0.5C18.2124 0.5 17.4378 0.529665 15.8985 0.664807C15.915 4.23453 15.9282 7.80756 15.9447 11.3773C16.8379 11.3344 17.2862 11.318 18.1828 11.3015C18.1828 9.81821 18.1795 9.07328 18.1762 7.59001V7.59331ZM18.1663 2.59635C18.6969 2.57987 18.9606 2.57328 19.4913 2.57328C19.8902 2.57328 20.2099 2.71171 20.4538 2.99189C20.6944 3.26876 20.8164 3.63793 20.8164 4.0895V4.10269C20.8164 4.55756 20.6977 4.91684 20.4604 5.18382C20.2231 5.45081 19.9066 5.58595 19.5045 5.58595C18.9705 5.58595 18.7035 5.59255 18.1696 5.60573C18.1696 4.40264 18.1696 3.79944 18.163 2.59635H18.1663ZM32.2046 8.60522C32.1683 9.33697 31.9804 9.95994 31.6376 10.4906C31.2948 11.018 30.8301 11.4135 30.2466 11.6772C29.6632 11.9409 28.9908 12.0365 28.2327 11.9508C27.3625 11.8552 26.6077 11.5718 25.9715 11.0839C25.3354 10.5961 24.8476 9.93028 24.5048 9.07657C24.162 8.22617 23.9906 7.21755 23.9972 6.0606C23.9972 6.0606 23.9972 6.0573 23.9972 6.05401C24.0037 4.89376 24.1817 3.91481 24.541 3.12703C24.897 2.33925 25.4013 1.76902 26.0474 1.43281C26.6934 1.09331 27.4548 1.0109 28.3283 1.18889C29.0963 1.34711 29.7654 1.68332 30.3455 2.17774C30.9224 2.67216 31.3739 3.26547 31.7035 3.94777C32.0299 4.63007 32.2046 5.34204 32.221 6.09027C32.221 6.11663 32.2243 6.12982 32.2276 6.15289C31.3805 5.93864 30.9553 5.84305 30.1016 5.66506C30.0983 5.62551 30.095 5.60573 30.0917 5.56288C30.0456 5.19371 29.95 4.85751 29.8017 4.55426C29.6533 4.25101 29.4556 3.99392 29.2051 3.78626C28.9546 3.5786 28.6579 3.44016 28.3151 3.37424C27.9097 3.29843 27.557 3.36765 27.257 3.5753C26.9571 3.78296 26.7231 4.11917 26.555 4.57733C26.3902 5.0355 26.3045 5.60244 26.2979 6.27485C26.2979 6.27485 26.2979 6.27815 26.2979 6.28144C26.2946 6.96045 26.3704 7.55046 26.5286 8.05806C26.6868 8.56238 26.9142 8.96121 27.2142 9.25127C27.5108 9.54133 27.8635 9.71273 28.2657 9.76547C28.5887 9.80832 28.8754 9.77206 29.126 9.6567C29.3765 9.54463 29.5841 9.36004 29.7489 9.10954C29.9137 8.85903 30.0225 8.54919 30.0785 8.17673C30.0851 8.15036 30.0851 8.13717 30.0917 8.10751C30.9421 8.25913 31.3673 8.34483 32.2144 8.52941C32.2144 8.55908 32.2144 8.57556 32.2144 8.60522H32.2046ZM7.54279 14.0274C7.56916 16.605 7.57904 17.8938 7.60541 20.4681C7.612 21.2097 7.46697 21.8689 7.16373 22.4326C6.86378 22.9962 6.43528 23.4313 5.87823 23.7378C5.32118 24.0444 4.66196 24.1894 3.90055 24.1894C3.13914 24.1894 2.49309 24.0444 1.93275 23.7708C1.3724 23.4972 0.937312 23.1182 0.627474 22.6402C0.320933 22.1623 0.166016 21.6052 0.166016 20.9559V15.359C1.02631 15.1646 1.4581 15.0723 2.32169 14.9009C2.33487 17.1686 2.33818 18.2992 2.35136 20.5669C2.35136 21.0976 2.4865 21.5063 2.75349 21.7964C3.01718 22.0865 3.39623 22.2282 3.88736 22.2084C4.37848 22.1886 4.75425 22.0205 5.01464 21.6909C5.27504 21.3613 5.40029 20.913 5.397 20.3527C5.37393 17.9531 5.36404 16.7533 5.34426 14.3537C6.22103 14.212 6.65942 14.146 7.53949 14.0241L7.54279 14.0274ZM15.3975 15.0986C15.1305 14.5449 14.7548 14.123 14.2702 13.8362C13.7857 13.5527 13.2188 13.4341 12.5694 13.4868C11.7322 13.5527 11.2279 13.5989 10.5258 13.6714C9.95887 13.7274 9.53696 13.7769 8.85465 13.8593C8.88762 17.2411 8.92058 20.6263 8.95354 24.0081C9.83691 24.0081 10.2786 24.0081 11.1587 24.0048C11.1488 22.9929 11.1422 21.981 11.1323 20.9658C11.5905 20.9526 12.019 20.9394 12.6254 20.9262C13.2715 20.9097 13.8351 20.7482 14.3098 20.4285C14.7877 20.1121 15.1569 19.6671 15.4173 19.0969C15.6777 18.5266 15.8062 17.8575 15.8029 17.0961C15.8029 17.0895 15.8029 17.0862 15.8029 17.0829C15.7996 16.3149 15.6645 15.6524 15.3975 15.0986ZM13.1726 18.4475C12.9122 18.7442 12.5463 18.9024 12.0816 18.9222C11.6992 18.9386 11.4059 18.9518 11.1158 18.965C11.1059 17.8575 11.096 16.7533 11.0862 15.6458C11.3729 15.6227 11.6696 15.6029 12.0519 15.5766C12.52 15.5436 12.8858 15.6623 13.1528 15.9326C13.4198 16.1995 13.555 16.6116 13.5583 17.1653C13.5583 17.1719 13.5583 17.1752 13.5583 17.1785C13.5616 17.7257 13.433 18.1509 13.1726 18.4475ZM22.2271 13.7175C21.7459 13.3879 21.1756 13.2198 20.523 13.2132C19.6792 13.2066 19.1716 13.2066 18.4629 13.2165C17.8927 13.2231 17.4675 13.233 16.7786 13.2561C16.7918 16.8357 16.8017 20.4186 16.8148 23.9982C17.6982 23.9982 18.1399 23.9982 19.02 23.9982C19.02 22.9468 19.02 21.8953 19.02 20.8438C19.4781 20.8438 19.9099 20.8438 20.5164 20.8438C21.1625 20.8438 21.7261 20.6922 22.2073 20.3889C22.6886 20.0824 23.061 19.6506 23.328 19.087C23.595 18.5266 23.7302 17.8674 23.7335 17.106C23.7335 17.0994 23.7335 17.0961 23.7335 17.0928C23.7368 16.3281 23.6082 15.6557 23.3445 15.0789C23.0808 14.502 22.7084 14.0472 22.2271 13.7208V13.7175ZM21.4822 17.0565C21.4822 17.6136 21.3471 18.0388 21.0834 18.3289C20.8197 18.6189 20.4538 18.7639 19.9857 18.7639C19.6001 18.7639 19.3067 18.7639 19.0167 18.7639C19.0167 17.6169 19.0167 16.4665 19.0167 15.3162C19.3067 15.3162 19.6034 15.3162 19.989 15.3162C20.4604 15.3162 20.8263 15.4645 21.0899 15.7579C21.3536 16.0512 21.4855 16.4764 21.4855 17.0401C21.4855 17.0467 21.4855 17.05 21.4855 17.0532L21.4822 17.0565ZM24.7388 13.3517C27.1417 13.4868 28.3415 13.5956 30.7213 13.8889C30.7147 14.7163 30.7081 15.1316 30.7015 15.9589C29.2051 15.8106 28.4535 15.748 26.9505 15.6524C26.9439 16.483 26.9406 16.895 26.934 17.7257C28.3481 17.7949 29.0534 17.8377 30.4609 17.9432C30.4543 18.7211 30.451 19.1067 30.4411 19.8846C29.0337 19.8121 28.3283 19.7825 26.9175 19.7363C26.911 20.5867 26.9076 21.0119 26.9011 21.8623C28.4008 21.8887 29.149 21.9052 30.6422 21.948C30.6356 22.7754 30.629 23.1907 30.6224 24.018C28.2459 24.0114 27.056 24.0114 24.6762 24.0081L24.7355 13.3583L24.7388 13.3517ZM37.4487 20.5801C37.8937 20.4087 38.253 20.1088 38.5167 19.6836C38.7837 19.2617 38.9155 18.7771 38.9155 18.2168V18.2036C38.9155 17.5872 38.7903 17.0434 38.5398 16.5588C38.2893 16.0776 37.9267 15.6689 37.4454 15.3393C36.9675 15.0096 36.3841 14.7756 35.6919 14.6471C34.2086 14.3768 33.4637 14.2548 31.9639 14.0472C31.931 17.3664 31.898 20.6889 31.8684 24.0081C32.7517 24.0081 33.1934 24.0114 34.0735 24.0147C34.0867 22.6864 34.09 22.0238 34.1031 20.6955C34.5119 20.7186 34.7129 20.7317 35.1217 20.7581C35.1414 20.7581 35.1612 20.7581 35.1777 20.7614C35.1942 20.7647 35.2107 20.7614 35.2238 20.7614C35.804 22.0996 36.0973 22.7523 36.684 24.0213C37.6762 24.0246 38.1739 24.0279 39.166 24.0312C38.4738 22.7028 38.131 22.0107 37.4487 20.5768V20.5801ZM36.6939 17.8971C36.6939 18.2827 36.5752 18.5761 36.3478 18.7837C36.1171 18.9914 35.8072 19.0771 35.4183 19.0408C34.9008 18.9914 34.6404 18.9683 34.1196 18.9222C34.1295 17.8443 34.1328 17.3071 34.1427 16.2325C34.6569 16.3017 34.914 16.338 35.4249 16.4105C35.8105 16.4665 36.1171 16.6313 36.3511 16.9016C36.5818 17.1719 36.6972 17.4982 36.6972 17.8839C36.6972 17.8905 36.6972 17.8905 36.6972 17.8971H36.6939Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function TransformationArcIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 40 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.70841 2.70718C2.61891 3.03448 1.91499 3.28108 0.695463 3.74288C0.35023 7.89017 0.462318 12.3513 1.03173 16.4762C2.22884 15.8664 2.8386 15.5884 4.07158 15.0907C3.97742 14.082 3.90569 13.2032 3.85188 12.3827C5.30007 11.8043 6.47028 11.4277 7.96778 11.0556C8.40269 11.7505 8.85104 12.5082 9.36217 13.3825C10.64 13.0732 11.2856 12.9431 12.5769 12.7459C10.6624 9.06037 8.17403 5.36593 5.48838 2.19606C4.75756 2.39333 4.30472 2.51887 3.70841 2.70718ZM3.74428 10.114C3.71289 8.70169 3.74428 7.26695 3.8205 5.36593C3.8474 5.35696 3.86533 5.35248 3.89224 5.34351C5.06693 6.84101 5.92777 7.9888 6.72584 9.15453C5.66772 9.44147 4.78446 9.72394 3.74876 10.114H3.74428ZM22.4362 1.12449C21.5709 0.74787 20.4814 0.528175 19.1901 0.510241C16.4238 0.469889 15.0383 0.541626 12.2854 0.882376C12.8638 5.56769 13.1508 7.9081 13.7291 12.5934C14.9621 12.441 15.5853 12.3917 16.8273 12.3379C16.76 10.7148 16.7242 9.90328 16.6569 8.27575C17.2936 8.24885 17.6119 8.23988 18.2486 8.23988C18.28 8.23988 18.3113 8.23988 18.3382 8.23988C18.3651 8.23988 18.392 8.23988 18.41 8.23988C19.3336 9.86741 19.755 10.6924 20.4993 12.3603C21.8937 12.4365 22.5931 12.5037 23.9785 12.71C23.2746 10.7865 22.8621 9.82706 21.9206 7.94397C22.6469 7.72876 23.2612 7.35662 23.7678 6.80963C24.2745 6.26264 24.5928 5.61701 24.6959 4.86825C24.6959 4.86377 24.6959 4.85929 24.6959 4.85032C24.808 4.02535 24.6869 3.29004 24.3058 2.65786C23.9247 2.02568 23.3015 1.50559 22.4362 1.12897V1.12449ZM20.8849 4.49612C20.858 4.98931 20.6428 5.37489 20.2527 5.65736C19.8582 5.93982 19.347 6.06984 18.7059 6.06536C17.854 6.06088 17.4236 6.06536 16.5717 6.10123C16.5179 4.78307 16.491 4.12398 16.4327 2.8103C17.3384 2.77444 17.7957 2.76547 18.7014 2.76995C19.3829 2.76995 19.9299 2.94033 20.3289 3.25866C20.728 3.57699 20.9073 3.98499 20.8804 4.47818C20.8804 4.48267 20.8804 4.48715 20.8804 4.49612H20.8849ZM39.1509 9.89431C39.1419 9.92122 39.1374 9.93467 39.1285 9.96605C37.8238 9.30249 37.1557 8.99761 35.8151 8.44164C35.8241 8.39681 35.8286 8.37439 35.842 8.32956C35.9227 7.91707 35.9048 7.51355 35.7748 7.12348C35.6447 6.73341 35.4071 6.37473 35.0574 6.05191C34.7077 5.72909 34.2414 5.46456 33.6675 5.27177C32.9905 5.04311 32.3583 4.99828 31.7799 5.13278C31.2015 5.26281 30.7084 5.55872 30.3048 6.00708C29.9013 6.45543 29.6144 7.04726 29.4261 7.77808C29.4261 7.77808 29.4261 7.78256 29.4261 7.78705C29.2377 8.52235 29.2019 9.18143 29.305 9.77326C29.4081 10.3651 29.6323 10.8583 29.9865 11.2618C30.3407 11.6653 30.7935 11.9567 31.3674 12.1495C31.8248 12.302 32.2597 12.3692 32.6722 12.3379C33.0846 12.3109 33.4657 12.1944 33.8155 11.9881C34.1652 11.7864 34.4656 11.4949 34.7077 11.1183C34.7256 11.0914 34.7391 11.078 34.757 11.0511C36.0124 11.5712 36.6356 11.8536 37.8551 12.4768C37.8372 12.5082 37.8327 12.5262 37.8148 12.5575C37.3754 13.3197 36.7612 13.8847 35.9945 14.2882C35.2278 14.6917 34.3849 14.9024 33.4523 14.9473C32.5242 14.9921 31.5737 14.8397 30.5604 14.4989C29.3992 14.1089 28.4531 13.5932 27.6909 12.9073C26.9287 12.2213 26.3728 11.3963 26.0365 10.401C25.7002 9.40561 25.6106 8.28024 25.8258 7.02036V7.01139C26.041 5.74703 26.5073 4.71133 27.2695 3.93119C28.0317 3.15105 29.036 2.63993 30.2779 2.44714C31.5199 2.25434 32.9322 2.39782 34.4611 2.90894C35.8062 3.36178 36.9091 4.00741 37.7475 4.79652C38.586 5.58562 39.1195 6.44646 39.3616 7.33869C39.6037 8.23092 39.523 9.07831 39.1598 9.88535L39.1509 9.89431Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function TransformationArchIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 40 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00298 2.35812V2.35064C5.84201 2.39556 5.67729 2.44422 5.51632 2.48914C5.43022 2.5116 5.34412 2.53407 5.25801 2.56027C4.74515 2.71001 4.23603 2.8635 3.72692 3.02821C2.64129 6.66317 1.5669 10.3318 0.5 14.0379C1.34604 13.701 2.19956 13.3903 3.05682 13.102C3.25523 12.3159 3.45738 11.5335 3.65953 10.7473C4.70772 10.4067 5.76339 10.0997 6.82655 9.82645C7.0287 10.4928 7.2346 11.1591 7.43675 11.8292C8.31273 11.6158 9.19246 11.4249 10.0722 11.2565C8.96036 8.18303 7.85602 5.14704 6.75542 2.14848C6.50086 2.21212 6.25005 2.28699 5.99549 2.35437L6.00298 2.35812ZM4.16491 8.77825C4.51305 7.4231 4.8612 6.06795 5.21309 4.72028C5.22807 4.71654 5.24304 4.71279 5.26176 4.7053C5.61365 5.85082 5.96554 7.00009 6.31743 8.15309C5.59868 8.34401 4.87992 8.55364 4.16491 8.77825ZM18.671 5.47647C18.9818 4.9636 19.1352 4.39085 19.1352 3.75819V3.74323C19.1352 3.04693 18.9855 2.45545 18.6898 1.97628C18.394 1.49711 17.9635 1.13773 17.3983 0.909377C16.833 0.681022 16.1442 0.59866 15.3356 0.669786C13.8906 0.797066 12.4531 0.984242 11.0193 1.23131V11.0843C11.8616 10.9383 12.7039 10.8147 13.5499 10.7137V7.32203C13.943 7.27336 14.3323 7.23218 14.7254 7.191C14.7478 7.191 14.7703 7.18725 14.7928 7.18351C14.8152 7.18351 14.8302 7.17977 14.8452 7.17977C15.4142 8.25417 15.9869 9.33979 16.5597 10.4329C17.5143 10.3693 18.4726 10.3356 19.4272 10.3243C18.7609 9.07774 18.0908 7.84237 17.4245 6.62198C17.9448 6.37117 18.3566 5.98933 18.6673 5.47647H18.671ZM16.5335 3.85927C16.5335 4.2748 16.3987 4.61171 16.1329 4.88125C15.8672 5.15078 15.5078 5.30053 15.0548 5.3417C14.5532 5.39037 14.0515 5.44278 13.5537 5.50267V2.75118C14.0478 2.69129 14.5457 2.63514 15.0398 2.59021C15.4891 2.54904 15.8484 2.64637 16.1217 2.87473C16.395 3.10682 16.5298 3.42877 16.5298 3.8443C16.5298 3.84804 16.5298 3.85179 16.5298 3.85927H16.5335ZM27.0902 7.04875C27.9026 7.15731 28.7149 7.28833 29.5198 7.43433V7.50921C29.4861 8.23545 29.2802 8.85313 28.8909 9.36974C28.5053 9.8826 27.9774 10.2569 27.3148 10.5003C26.6485 10.7436 25.8848 10.8185 25.0163 10.7361C24.0205 10.6425 23.1558 10.3842 22.4258 9.94623C21.6958 9.50824 21.1343 8.91302 20.7375 8.1456C20.3407 7.37818 20.1423 6.46101 20.1423 5.39411V5.38663C20.1423 4.31598 20.3407 3.40256 20.7412 2.64637C21.138 1.89017 21.7033 1.32116 22.4333 0.95055C23.1633 0.579942 24.0243 0.433943 25.0163 0.527531C25.8886 0.609888 26.656 0.871938 27.3223 1.30244C27.9887 1.73295 28.509 2.27576 28.8946 2.92339C29.2764 3.57102 29.4823 4.27106 29.5085 5.01227C29.5085 5.03473 29.5123 5.05346 29.516 5.07592C28.7074 4.92618 27.8951 4.7989 27.079 4.69034C27.0753 4.65664 27.0715 4.62669 27.064 4.593C27.0079 4.24111 26.8956 3.91917 26.7234 3.63841C26.5512 3.3539 26.3228 3.12179 26.0346 2.93836C25.75 2.75493 25.4094 2.64263 25.0163 2.60519C24.5559 2.56027 24.1553 2.65011 23.8146 2.86723C23.474 3.08436 23.2119 3.41379 23.0285 3.85178C22.8451 4.28977 22.7515 4.82136 22.7515 5.45027V5.45775C22.7515 6.09041 22.8451 6.6407 23.0285 7.1049C23.2119 7.57284 23.4777 7.93596 23.8184 8.20175C24.1591 8.46754 24.5634 8.62103 25.0238 8.66595C25.3944 8.69964 25.7201 8.66595 26.0084 8.55364C26.2929 8.44133 26.5287 8.26913 26.7121 8.0258C26.8956 7.78247 27.0191 7.483 27.079 7.11988C27.0827 7.09742 27.0865 7.07496 27.094 7.0525L27.0902 7.04875ZM39.5 4.18869V14.0416C38.6951 13.7234 37.8828 13.424 37.0704 13.1469C37.0704 11.8255 37.0704 10.504 37.0704 9.17881C35.7939 8.74457 34.5024 8.35898 33.1997 8.0258C33.1997 9.34727 33.1997 10.6687 33.1997 11.9939C32.3686 11.7806 31.5375 11.5859 30.699 11.4137C30.699 8.13063 30.699 4.84756 30.699 1.56075C31.5375 1.73295 32.3686 1.92762 33.1997 2.141C33.1997 3.43251 33.1997 4.72028 33.1997 6.0118C34.4987 6.34497 35.7902 6.73055 37.0704 7.1648C37.0704 5.87328 37.0704 4.58551 37.0704 3.294C37.8865 3.57102 38.6951 3.87049 39.5 4.18869Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function TransformationBulgeIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 40 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.52861 9.57128C6.20691 9.28309 5.84834 9.13229 5.44956 9.10883V9.04516C5.77797 8.97144 6.07286 8.80053 6.3376 8.51569C6.60234 8.23085 6.8101 7.86558 6.96425 7.41988C7.1184 6.97418 7.19548 6.47823 7.19548 5.9454V5.9253C7.19548 5.19141 7.08489 4.5748 6.86372 4.109C6.64255 3.6432 6.32419 3.3349 5.91201 3.19415C5.49983 3.05341 5.01057 3.09697 4.44088 3.31144C3.47912 3.67336 2.91278 3.90123 2.10517 4.26315C1.55894 4.50108 1.15346 4.69209 0.5 5.0138V13.8339C1.15346 14.1556 1.55559 14.3466 2.10182 14.5845C2.94965 14.9665 3.53608 15.2011 4.53806 15.5764C5.15466 15.8043 5.69084 15.8445 6.14659 15.6669C6.60233 15.4893 6.9542 15.1207 7.20553 14.5711C7.45686 14.0215 7.58085 13.3178 7.58085 12.4901V12.47C7.58085 11.84 7.48703 11.2669 7.29601 10.7609C7.105 10.2583 6.85032 9.85948 6.52526 9.56793L6.52861 9.57128ZM4.71902 5.81136C4.93014 6.01242 5.03738 6.33748 5.03738 6.77647V6.79323C5.03738 7.26573 4.92344 7.65111 4.69221 7.9326C4.46434 8.21409 4.12923 8.36154 3.69694 8.3917C3.27135 8.42186 2.953 8.44532 2.63464 8.46877V5.97221C3.00326 5.87168 3.36183 5.77784 3.85779 5.65385C4.22306 5.56337 4.51125 5.61029 4.72237 5.81136H4.71902ZM5.31887 11.9472C5.31887 12.4633 5.19823 12.8419 4.95695 13.0631C4.71567 13.2843 4.37051 13.3312 3.92481 13.2206C3.40204 13.0899 3.02672 12.9927 2.63799 12.8855V10.2013C3.00661 10.2247 3.36518 10.2449 3.86114 10.2717C4.18285 10.2884 4.45093 10.3588 4.66875 10.4861C4.88657 10.6135 5.05078 10.8011 5.15802 11.0458C5.2686 11.2904 5.32222 11.5853 5.32222 11.9237V11.9405L5.31887 11.9472ZM13.9379 0.91541C14.8527 0.788069 15.3118 0.737804 16.2334 0.660729V11.974C16.2334 13.2776 16.0725 14.4203 15.7542 15.3787C15.4358 16.3371 14.9834 17.0543 14.4037 17.5167C13.8239 17.9792 13.137 18.1367 12.3528 17.9926C11.5787 17.8518 10.9051 17.4531 10.3287 16.8465C9.75236 16.24 9.31002 15.4793 8.99501 14.5812C8.68001 13.6831 8.52251 12.6979 8.52251 11.5853V2.01122C9.4206 1.76994 9.86965 1.6627 10.7778 1.47169V11.3574C10.7778 12.2823 10.9118 13.0196 11.1866 13.5792C11.4581 14.1388 11.8501 14.4572 12.3595 14.5108C12.8689 14.5644 13.261 14.3265 13.5324 13.7903C13.8038 13.2541 13.9412 12.48 13.9412 11.4915V0.918764L13.9379 0.91541ZM19.9095 14.7052C21.4108 14.7052 22.1615 14.6884 23.6594 14.6147V18.2037C21.2433 18.4048 20.0235 18.4215 17.604 18.2908V0.563549C18.5255 0.513283 18.988 0.499878 19.9095 0.499878V14.7052ZM28.609 8.64973C30.1974 8.67989 30.9882 8.7 32.5498 8.74356V10.5297C32.5498 11.8266 32.3923 12.9525 32.0773 13.9646C31.7623 14.9766 31.3066 15.8311 30.7067 16.5114C30.1069 17.1917 29.3831 17.6508 28.5352 17.825C27.6137 18.0127 26.8195 17.8016 26.1593 17.1883C25.4958 16.5751 24.9831 15.5965 24.6245 14.2695C24.2659 12.9458 24.085 11.3139 24.085 9.40038V9.39032C24.085 7.49361 24.2626 5.87503 24.6212 4.5614C24.9764 3.25112 25.4857 2.27931 26.1392 1.66606C26.7927 1.05281 27.5735 0.845038 28.4749 1.026C29.2054 1.17344 29.8556 1.56217 30.4252 2.14191C30.9949 2.725 31.454 3.43208 31.8092 4.24975C32.1645 5.06742 32.3756 5.92865 32.4493 6.86025C32.4527 6.90716 32.456 6.93062 32.4627 6.98089C31.5814 6.89376 31.1357 6.85354 30.2443 6.77982C30.2342 6.73626 30.2309 6.7128 30.2208 6.66924C30.1069 6.03588 29.8991 5.52316 29.5975 5.12773C29.2959 4.73231 28.9273 4.49773 28.4883 4.44411C28.0627 4.39384 27.6975 4.54465 27.3892 4.90321C27.0809 5.26178 26.8463 5.81806 26.6821 6.56871C26.5179 7.31935 26.4374 8.2476 26.4374 9.34341V9.35681C26.4374 10.466 26.5246 11.4144 26.7022 12.1918C26.8798 12.9693 27.1278 13.5457 27.4528 13.9244C27.7745 14.2997 28.1532 14.4572 28.5888 14.4069C28.9307 14.3667 29.2323 14.2192 29.4936 13.978C29.755 13.7367 29.9628 13.4183 30.1203 13.0196C30.2744 12.6208 30.3649 12.1717 30.385 11.6557C30.3884 11.5786 30.3917 11.5384 30.3984 11.4613C29.6914 11.5049 29.3361 11.5283 28.6224 11.5652V8.64973H28.609ZM35.8574 5.88173V8.25095C37.2481 8.35483 37.935 8.41516 39.2855 8.5425V10.2683C37.935 10.3889 37.2481 10.4459 35.8574 10.5464V12.976C37.3352 12.6409 38.0657 12.4532 39.5 12.0377V13.8406C37.2213 14.9598 36.045 15.4357 33.659 16.2064V2.65463C36.0484 3.42873 37.2213 3.90123 39.5 5.0205V6.82339C38.0657 6.40785 37.3385 6.22019 35.8574 5.88173Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function TransformationDistortIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 49 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.89329 3.6299C5.31357 3.44796 4.61358 3.39245 3.80258 3.44488C2.70172 3.51888 1.60086 3.58981 0.5 3.66382C0.5 5.31357 0.5 6.96332 0.5 8.61307C1.60086 8.68707 2.70172 8.75799 3.80258 8.832C4.61975 8.88751 5.31974 8.82275 5.89638 8.63157C6.4761 8.44038 6.92015 8.12893 7.22543 7.69722C7.53379 7.2686 7.68797 6.73204 7.68797 6.10606C7.68797 6.10606 7.68797 6.0999 7.68797 6.09681C7.68797 5.47083 7.53379 4.94045 7.22543 4.52724C6.91706 4.11095 6.47302 3.81183 5.89329 3.63298V3.6299ZM5.58493 6.10914C5.58493 6.48227 5.50784 6.79371 5.35058 7.04041C5.19639 7.28401 4.96204 7.46287 4.65676 7.57696C4.34839 7.69106 3.97218 7.73423 3.52505 7.71881C3.20436 7.70647 2.88366 7.69414 2.56296 7.6818C2.56296 6.65495 2.56296 5.6281 2.56296 4.60124C2.88366 4.58891 3.20436 4.57657 3.52505 4.56424C3.95676 4.54882 4.3268 4.59199 4.63517 4.703C4.94353 4.81401 5.18098 4.9867 5.34132 5.22414C5.50167 5.46158 5.58185 5.75761 5.58185 6.10606V6.11531L5.58493 6.10914ZM8.69324 3.12418C9.3809 3.07792 10.0686 3.03475 10.7562 2.9885C10.7562 5.08846 10.7562 7.19151 10.7562 9.29147C10.0686 9.24521 9.3809 9.20204 8.69324 9.15579V3.12418ZM18.5362 7.53996V7.54612C18.5362 8.03334 18.4006 8.45272 18.1323 8.795C17.8609 9.13728 17.4724 9.38706 16.9636 9.54432C16.4548 9.70159 15.8411 9.75093 15.1257 9.70159C14.4504 9.65534 13.8645 9.53507 13.368 9.34389C12.8716 9.1527 12.483 8.90601 12.2055 8.60073C11.9249 8.29545 11.7707 7.94083 11.7368 7.5307C11.7368 7.50295 11.7337 7.47828 11.7306 7.45053C12.3689 7.46903 13.0103 7.48445 13.6487 7.50295C13.6517 7.51837 13.6548 7.53379 13.661 7.54921C13.698 7.69414 13.7843 7.82365 13.9231 7.93467C14.0588 8.04568 14.2346 8.13818 14.4504 8.20602C14.6632 8.27695 14.9006 8.31703 15.1658 8.32628C15.4403 8.33862 15.6746 8.31704 15.872 8.26153C16.0693 8.20603 16.2204 8.12585 16.3314 8.01792C16.4394 7.90999 16.4949 7.78357 16.4949 7.63863V7.63247C16.4949 7.43203 16.3962 7.27785 16.1958 7.16375C15.9984 7.04966 15.6592 6.95406 15.1843 6.8708C14.9068 6.82147 14.6293 6.77213 14.3517 6.72279C13.55 6.58711 12.9394 6.362 12.52 6.04747C12.1007 5.73294 11.8941 5.33515 11.8941 4.83868C11.8941 4.83868 11.8941 4.83869 11.8941 4.8356C11.8941 4.42239 12.0328 4.05852 12.3104 3.73474C12.5879 3.41404 12.9703 3.14885 13.4544 2.94533C13.9385 2.74181 14.4905 2.61229 15.1103 2.5722C15.7887 2.52595 16.3653 2.5722 16.8433 2.71714C17.3182 2.86207 17.6882 3.09026 17.9473 3.40171C18.2063 3.71315 18.3481 4.09244 18.3728 4.53649C18.3728 4.57041 18.3759 4.60741 18.379 4.64133C17.7407 4.65983 17.0993 4.67525 16.4609 4.69375C16.4609 4.67525 16.4579 4.65675 16.4548 4.64133C16.4332 4.48407 16.3623 4.35455 16.2482 4.24663C16.131 4.14178 15.9768 4.06161 15.7856 4.0061C15.5944 3.95368 15.3755 3.93209 15.1288 3.94134C14.8759 3.95059 14.6632 3.99068 14.4874 4.05852C14.3116 4.12636 14.176 4.20962 14.0865 4.31447C13.994 4.41931 13.9478 4.53341 13.9478 4.66292C13.9478 4.66292 13.9478 4.666 13.9478 4.66908C13.9478 4.84793 14.0464 4.98979 14.2469 5.09155C14.4442 5.19331 14.7619 5.27656 15.1966 5.33823C15.4742 5.37832 15.7517 5.41841 16.0292 5.46158C16.8927 5.59418 17.5279 5.82237 17.9349 6.14923C18.342 6.4761 18.5486 6.94173 18.5486 7.5307L18.5362 7.53996ZM18.9124 2.45194C21.0895 2.30701 23.2696 2.16517 25.4467 2.02023C25.4467 2.58146 25.4467 3.14268 25.4467 3.70391C24.7035 3.73166 23.9573 3.76249 23.2141 3.79025V10.1117C22.5265 10.0655 21.8388 10.0223 21.1512 9.97604C21.1512 7.94083 21.1512 5.90563 21.1512 3.87042C20.4049 3.89817 19.6587 3.92901 18.9124 3.95676C18.9124 3.45413 18.9124 2.95149 18.9124 2.44886V2.45194ZM31.8144 2.01098C31.2131 1.66562 30.5008 1.52685 29.6774 1.58544C28.8634 1.64094 28.1572 1.8753 27.5559 2.26693C26.9546 2.66163 26.492 3.18585 26.1652 3.83958C25.8383 4.49331 25.6718 5.25498 25.6718 6.13381C25.6718 6.1369 25.6718 6.13998 25.6718 6.14615C25.6718 7.02499 25.8352 7.78665 26.1621 8.44347C26.489 9.10028 26.9515 9.6245 27.5497 10.0192C28.151 10.4139 28.8572 10.6452 29.6744 10.7007C30.5039 10.7562 31.2162 10.6205 31.8144 10.2752C32.4126 9.92978 32.8721 9.40556 33.199 8.69941C33.5227 7.99634 33.6862 7.13908 33.6862 6.14923V6.1369C33.6862 5.14705 33.5227 4.28979 33.199 3.58981C32.8752 2.88674 32.4126 2.36252 31.8113 2.01715L31.8144 2.01098ZM31.5831 6.14615C31.5831 6.71046 31.506 7.20076 31.3519 7.61088C31.1977 8.02101 30.9787 8.33554 30.6981 8.55139C30.4144 8.76725 30.0752 8.86284 29.6774 8.84742C29.2951 8.832 28.962 8.70866 28.6753 8.48355C28.3916 8.25845 28.1695 7.94391 28.0154 7.54612C27.8612 7.14833 27.781 6.68271 27.781 6.14615V6.13381C27.781 5.59418 27.8581 5.12546 28.0154 4.73076C28.1695 4.33605 28.3916 4.0246 28.6783 3.7995C28.9651 3.57439 29.2981 3.45413 29.6774 3.43871C30.0691 3.42329 30.4052 3.51889 30.6889 3.73166C30.9726 3.94443 31.1946 4.25588 31.3488 4.66292C31.503 5.07304 31.5831 5.56334 31.5831 6.13073V6.14306V6.14615ZM40.9081 6.21091C41.1578 5.6836 41.2843 5.08537 41.2843 4.42239C41.2843 4.41622 41.2843 4.41314 41.2843 4.40698C41.2843 3.67615 41.164 3.05942 40.9235 2.56295C40.683 2.06649 40.3345 1.69953 39.8781 1.46518C39.4218 1.23082 38.8636 1.13831 38.2068 1.18148C37.035 1.25857 35.8632 1.33566 34.6914 1.41276C34.6914 4.56732 34.6914 7.71881 34.6914 10.8734C35.3791 10.9196 36.0667 10.9628 36.7544 11.0091C36.7544 9.89278 36.7544 8.77341 36.7544 7.65714C37.072 7.6633 37.3927 7.66947 37.7103 7.67564C37.7288 7.67564 37.7473 7.67564 37.7628 7.67564C37.7813 7.67564 37.7936 7.67564 37.8059 7.67564C38.2685 8.81967 38.731 9.9822 39.1936 11.1663C39.9676 11.2187 40.7416 11.2681 41.5156 11.3205C40.9759 9.96679 40.4363 8.64082 39.8966 7.33952C40.316 7.11133 40.6521 6.73513 40.9019 6.20782L40.9081 6.21091ZM39.1751 4.46248C39.1751 4.88494 39.0671 5.22414 38.8513 5.48008C38.6354 5.73294 38.3456 5.85937 37.9755 5.86246C37.5685 5.86246 37.1614 5.86554 36.7544 5.86862C36.7544 4.96203 36.7544 4.05544 36.7544 3.15193C37.1584 3.13651 37.5592 3.11801 37.9632 3.10259C38.3271 3.08717 38.62 3.20127 38.839 3.44796C39.061 3.69465 39.172 4.03077 39.172 4.45323C39.172 4.45631 39.172 4.46248 39.172 4.46557L39.1751 4.46248ZM48.5 0.503082C48.5 1.27091 48.5 2.04182 48.5 2.80965C47.7568 2.8374 47.0106 2.86824 46.2674 2.89599C46.2674 5.81003 46.2674 8.72099 46.2674 11.635C45.5798 11.5888 44.8921 11.5456 44.2045 11.4994C44.2045 8.65932 44.2045 5.8162 44.2045 2.97617C43.4582 3.00392 42.712 3.03475 41.9658 3.06251C41.9658 2.35327 41.9658 1.64403 41.9658 0.931708C44.1428 0.786777 46.3229 0.644931 48.5 0.5V0.503082Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function TransformationFishIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 40 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.92231 0.521764V4.06145C6.72712 4.02722 5.63198 4.08589 3.4368 4.49657C3.4368 5.93884 3.4368 6.66242 3.4368 8.10469C5.43153 8.01669 6.4289 8.00203 8.41875 8.00203V11.3755C6.42401 11.3755 5.42664 11.3461 3.4368 11.1848C3.4368 13.5462 3.4368 14.7245 3.4368 17.0859C2.12653 16.6654 1.47139 16.3819 0.166016 15.6045C0.166016 10.4563 0.166016 7.88469 0.166016 2.73651C3.66658 0.658657 5.42174 0.423986 8.92231 0.516878V0.521764ZM10.3744 17.741C11.6846 17.6188 12.3398 17.5015 13.6452 17.2277V1.12801C12.3349 0.849334 11.6798 0.736884 10.3744 0.614658V17.7459V17.741ZM25.0073 9.19984C24.3571 8.75005 23.3499 8.37848 21.9859 8.07047C21.4579 7.95313 21.1939 7.88958 20.6658 7.75757C19.9765 7.58646 19.4729 7.38111 19.16 7.14155C18.8471 6.90198 18.6858 6.60375 18.6858 6.24196V6.23218C18.6858 5.97795 18.7591 5.75795 18.9058 5.58194C19.0525 5.40594 19.2627 5.28371 19.5414 5.22015C19.82 5.15659 20.1574 5.16637 20.5583 5.2397C20.9494 5.31304 21.2965 5.43038 21.5996 5.58683C21.9028 5.74328 22.1472 5.92417 22.333 6.12952C22.5188 6.33486 22.6264 6.55975 22.6606 6.80909C22.6606 6.84332 22.6654 6.86287 22.6703 6.89709C23.8877 7.03399 24.494 7.09755 25.7113 7.20511C25.7113 7.14644 25.7064 7.122 25.7016 7.06333C25.6673 6.47664 25.4424 5.94862 25.0269 5.43038C24.6113 4.91214 24.0295 4.4379 23.2766 3.97344C22.5237 3.51387 21.6045 3.09341 20.5289 2.76584C19.5462 2.46761 18.6711 2.36005 17.9035 2.50672C17.1359 2.65828 16.5297 3.04451 16.0897 3.66543C15.6497 4.28634 15.4296 5.11259 15.4296 6.0904V6.10018C15.4296 7.26867 15.7621 8.25137 16.4221 8.97006C17.087 9.68386 18.0502 10.1239 19.3262 10.2999C19.8543 10.3781 20.1183 10.4123 20.6463 10.4808C21.3992 10.5688 21.937 10.6861 22.2499 10.8328C22.5628 10.9843 22.7241 11.2092 22.7241 11.5221V11.5319C22.7241 11.7617 22.6361 11.9768 22.465 12.1773C22.2939 12.3777 22.0494 12.5586 21.7365 12.72C21.4236 12.8813 21.0521 13.0035 20.617 13.0866C20.2014 13.1649 19.8249 13.1795 19.4827 13.1258C19.1453 13.072 18.8667 12.9546 18.6467 12.7737C18.4266 12.5928 18.2898 12.3533 18.2311 12.0648C18.2262 12.0257 18.2213 12.0111 18.2115 11.9719C16.9941 12.1186 16.3879 12.1871 15.1705 12.3142C15.1705 12.3924 15.1754 12.4266 15.1803 12.5048C15.2341 13.4778 15.4834 14.2796 15.9234 14.8663C16.3683 15.4481 16.9795 15.8001 17.7715 15.9174C18.5587 16.0299 19.4876 15.893 20.5583 15.5654C21.6925 15.2183 22.6655 14.7734 23.4721 14.2894C24.2788 13.8004 24.8997 13.2969 25.3251 12.7493C25.7553 12.2017 25.9656 11.6346 25.9656 11.0039C25.9656 10.2314 25.6429 9.65452 24.9926 9.20473L25.0073 9.19984ZM35.8953 4.22278C35.8953 5.7775 35.8953 6.55975 35.8953 8.11447C33.8467 8.25625 32.82 8.27581 30.7666 8.27581V4.97081C29.4563 4.96103 28.8012 4.89258 27.4958 4.69213V13.6587C28.8061 13.4582 29.4612 13.3898 30.7666 13.38V9.99187C32.8151 9.99187 33.8419 10.0114 35.8953 10.1385C35.8953 11.7324 35.8953 12.5293 35.8953 14.128C37.2055 14.5485 37.8606 14.832 39.166 15.6094V2.74139C37.8557 3.51875 37.2006 3.80232 35.8953 4.22278Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function TransformationInflateIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 40 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.50692 7.31416C3.86886 7.28321 3.54983 7.26654 2.91415 7.23083C-0.304718 5.80233 -0.304718 2.393 2.91415 0.964507C3.55221 0.928795 3.87124 0.912128 4.50692 0.881177C1.57137 2.45966 1.57137 5.73567 4.50692 7.31416ZM10.9328 0.628811C10.2971 0.647857 9.98043 0.657378 9.34476 0.678806C7.86865 2.25729 7.55676 3.04534 7.78294 4.62145C7.75675 4.62145 7.73294 4.62145 7.70913 4.62145C6.34492 3.20962 5.97113 2.29777 6.81394 0.77642C6.27111 0.800229 6.00208 0.812133 5.45925 0.835941C2.69512 2.49776 2.69512 5.69758 5.45925 7.35939C6.09731 7.39034 6.41634 7.40225 7.05202 7.43082C5.24022 5.87614 4.86167 5.1 5.16165 3.54532C5.18546 3.54532 5.20689 3.54532 5.22831 3.54532C6.17826 5.26427 8.10673 6.4404 9.59712 7.52605C10.1328 7.5451 10.3995 7.55224 10.9351 7.56891C9.32095 4.41432 9.32095 3.7834 10.9351 0.628811H10.9328ZM11.8827 7.5951C12.5208 7.61177 12.8398 7.6189 13.4755 7.63319C12.8922 6.57848 12.7089 6.05233 12.5589 4.99762C13.6659 5.00238 14.2183 5.00476 15.3254 5.00714C15.2778 4.45003 15.2706 4.17148 15.2968 3.61436C14.1826 3.61436 13.6255 3.61674 12.5112 3.61912C12.5589 2.97392 12.6255 2.65251 12.835 2.00731C14.0064 1.99302 14.5945 1.98826 15.7658 1.98112C15.8777 1.39543 15.9539 1.10259 16.142 0.516912C14.4373 0.538339 13.5826 0.555004 11.8779 0.597859C10.4518 3.73816 10.4518 4.45003 11.8779 7.59033L11.8827 7.5951ZM18.2966 6.22613C18.1205 3.93578 18.1514 2.7906 18.449 0.500244C17.811 0.502625 17.4919 0.50501 16.8562 0.512153C16.2158 2.68108 16.2158 5.51664 16.8562 7.68556C18.53 7.70223 19.368 7.70461 21.0417 7.69985C21.0917 7.11179 21.1132 6.81657 21.1417 6.2285C20.0037 6.2285 19.4347 6.2285 18.2966 6.2285V6.22613ZM25.4867 0.54548C26.8176 2.63346 28.5199 4.94048 27.5961 7.60938C26.9247 7.62605 26.5914 7.63319 25.92 7.64509C26.0653 7.06655 26.1415 6.5642 26.1605 6.09518C25.3344 6.10232 24.6868 6.10708 23.8749 6.11184C23.6511 6.58563 23.394 7.0975 23.0964 7.68556C22.425 7.69271 22.0917 7.69509 21.4203 7.69747C22.3559 5.41665 23.4797 3.0382 23.5297 0.514528C24.0273 0.51929 24.3154 0.524054 24.7463 0.531196C24.9963 0.535958 25.182 0.538336 25.482 0.543097L25.4867 0.54548ZM24.4273 4.79763C24.9891 4.79763 25.4724 4.79525 26.051 4.79287C25.8772 3.98577 25.5129 3.16676 24.9844 2.08349C24.9844 2.08349 24.9629 2.08349 24.951 2.08349C24.8844 3.162 24.713 3.98339 24.4273 4.79763ZM33.3173 2.10968C32.9649 1.55971 32.7292 1.28354 32.134 0.733567C30.115 0.655 29.1056 0.624051 27.089 0.578815C27.4366 1.15497 27.5747 1.44305 27.7795 2.01921C28.5389 2.02873 28.9175 2.03349 29.677 2.0454C30.6722 4.25956 30.4984 5.36665 28.8175 7.57843C29.4556 7.55939 29.7746 7.54986 30.4103 7.52843C32.3959 5.34522 32.6006 4.2548 31.4245 2.07397C32.1816 2.08826 32.5602 2.09539 33.3173 2.11206V2.10968ZM39.3931 4.68573C39.5383 4.20481 39.536 3.96434 39.3836 3.48341C38.2217 3.47151 37.6408 3.46675 36.4766 3.45723C36.3433 2.94059 36.2076 2.68346 35.8052 2.16682C36.9909 2.19539 37.5837 2.21205 38.7693 2.24777C38.2741 1.73589 37.9408 1.47876 37.1004 0.966883C35.3838 0.87165 34.5243 0.831178 32.8054 0.759753C35.2529 2.56918 35.2529 5.62854 32.8054 7.43796C34.5219 7.36654 35.3814 7.32606 37.1004 7.23083C37.9384 6.71895 38.2717 6.46183 38.7693 5.94995C37.5837 5.98566 36.9909 6.00233 35.8052 6.0309C36.2195 5.50235 36.3552 5.23808 36.4837 4.70716C37.648 4.69764 38.2289 4.69287 39.3907 4.68335L39.3931 4.68573Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function TransformationRiseIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 34 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.82703 16.7695C9.17502 16.0348 9.35116 15.3045 9.35116 14.5784V14.5613C9.35116 13.7622 9.1836 13.1607 8.84851 12.7483C8.51341 12.3359 8.02795 12.1168 7.39212 12.0695C6.75629 12.0222 5.97869 12.1554 5.06361 12.4132C3.43108 12.8772 1.79855 13.1478 0.166016 13.1478V24.4553C1.12405 24.4553 2.08209 24.3608 3.04013 24.1889V20.2966C3.48263 20.2193 3.92944 20.1205 4.37194 20.0088C4.39771 20.0002 4.42348 19.9959 4.44496 19.9916C4.47074 19.9873 4.48793 19.9787 4.50512 19.9787C5.14954 21.1129 5.79396 22.2127 6.43838 23.2867C7.51671 22.913 8.59504 22.4662 9.67337 21.9678C8.92155 20.8766 8.16972 19.7596 7.4179 18.6125C8.00217 18.1271 8.47044 17.5041 8.81843 16.7738L8.82703 16.7695ZM6.4126 15.7513C6.4126 16.2282 6.26223 16.6578 5.9615 17.0444C5.66077 17.4268 5.25694 17.6974 4.7414 17.8349C4.17431 17.9853 3.60722 18.1142 3.04013 18.2173V15.0596C3.60293 14.9608 4.16142 14.8319 4.72421 14.6816C5.23115 14.5441 5.63929 14.5613 5.94431 14.7503C6.25363 14.935 6.4083 15.2615 6.4083 15.7384C6.4083 15.7427 6.4083 15.747 6.4083 15.7556L6.4126 15.7513ZM10.7947 10.1276C11.7527 9.65507 12.7107 9.14813 13.6688 8.624V19.9314C12.7107 20.4556 11.7527 20.9625 10.7947 21.4351C10.7947 17.6674 10.7947 13.8997 10.7947 10.1276ZM24.5079 10.6088V10.6174C24.5079 11.3692 24.3189 12.1082 23.9451 12.8342C23.5714 13.5646 23.0258 14.2476 22.3169 14.9092C21.608 15.5709 20.7531 16.1723 19.7564 16.7222C18.8155 17.2421 17.9993 17.5686 17.3076 17.6931C16.6159 17.8177 16.0746 17.7361 15.688 17.4483C15.297 17.1604 15.0822 16.6707 15.0349 15.9747C15.0349 15.9274 15.0306 15.8845 15.0264 15.8372C15.9157 15.3389 16.8092 14.8276 17.6985 14.325C17.7028 14.3465 17.7071 14.3722 17.7157 14.3937C17.7673 14.6085 17.8876 14.7546 18.0809 14.8276C18.2699 14.9007 18.5148 14.905 18.8155 14.8405C19.112 14.7761 19.4428 14.6429 19.8122 14.441C20.1946 14.2305 20.5211 14.0028 20.7961 13.7536C21.071 13.5044 21.2815 13.2509 21.4362 12.9932C21.5866 12.7354 21.6639 12.4905 21.6639 12.2542C21.6639 12.2542 21.6639 12.2499 21.6639 12.2457C21.6639 11.9277 21.5264 11.7516 21.2472 11.7215C20.9722 11.6914 20.4996 11.7945 19.838 12.0351C19.4514 12.1726 19.0647 12.3101 18.6781 12.4519C17.5611 12.8729 16.7104 12.9803 16.1262 12.7655C15.5419 12.5507 15.254 12.0051 15.254 11.1372V11.1287C15.254 10.4026 15.4474 9.66366 15.834 8.90754C16.2207 8.15572 16.7534 7.43826 17.4279 6.75947C18.1067 6.08069 18.8757 5.49641 19.7349 5.02383C20.6801 4.504 21.4834 4.21616 22.1493 4.15602C22.8109 4.09587 23.3265 4.24194 23.6874 4.57704C24.0525 4.91214 24.2459 5.41908 24.2802 6.08928C24.2802 6.14083 24.2845 6.19668 24.2888 6.24823C23.3995 6.65637 22.5059 7.09887 21.6166 7.56285C21.6166 7.53707 21.6123 7.507 21.608 7.48122C21.578 7.24923 21.4791 7.08169 21.3202 6.99147C21.1569 6.90125 20.9421 6.87547 20.6758 6.91843C20.4094 6.96139 20.1044 7.07739 19.7607 7.27072C19.4127 7.46404 19.112 7.67885 18.8671 7.91514C18.6222 8.15142 18.4332 8.39201 18.3086 8.6326C18.1797 8.87318 18.1153 9.10087 18.1153 9.31568V9.32427C18.1153 9.6293 18.2528 9.78825 18.532 9.80974C18.807 9.83122 19.2495 9.72811 19.8552 9.5133C20.2419 9.37582 20.6285 9.23834 21.0152 9.10516C22.2181 8.69273 23.1031 8.6326 23.6702 8.87318C24.2373 9.11376 24.5251 9.70232 24.5251 10.6088H24.5079ZM28.7138 3.54167V5.77566C30.2433 5.34175 31.7684 5.07969 33.2978 5.04962C33.2978 5.77137 33.2978 6.49312 33.2978 7.21058C31.7684 7.24065 30.2433 7.5027 28.7138 7.93661V10.2265C30.3378 9.76677 31.9617 9.49611 33.5857 9.49611V11.8074C31.0037 11.8074 28.4217 12.4862 25.8354 13.5345C25.8354 9.76678 25.8354 5.99906 25.8354 2.22706C28.4174 1.18309 30.9994 0.5 33.5857 0.5V2.81132C31.9617 2.81132 30.3378 3.08199 28.7138 3.54167Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function TransformationSqueezeIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 40 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.07577 4.26584C6.37412 4.57898 6.50233 5.0154 6.31494 5.57263C6.31494 5.57263 6.31494 5.5751 6.31494 5.57756C6.15961 6.03864 5.83414 6.43807 5.39279 6.77093C4.95144 7.10379 4.4164 7.35529 3.83944 7.52296C3.26248 7.69062 2.67319 7.76212 2.12088 7.73993C1.60063 7.71774 1.25298 7.61911 1.07792 7.44652C0.902859 7.27392 0.900395 7.03723 1.00642 6.73642C1.11244 6.43561 1.32448 6.08056 1.53653 5.66633C1.55379 5.63428 1.56118 5.61701 1.57844 5.58496C2.10856 5.59482 2.37485 5.59975 2.90496 5.60962C2.90003 5.62688 2.8951 5.63674 2.89017 5.65647C2.84332 5.80194 2.82853 5.92769 2.85565 6.03618C2.88277 6.14466 2.94687 6.23096 3.0529 6.29507C3.15892 6.35917 3.30686 6.39369 3.49425 6.39862C3.68903 6.40355 3.87889 6.3789 4.06135 6.31972C4.24134 6.26301 4.40407 6.18164 4.54215 6.07562C4.68022 5.9696 4.78131 5.84632 4.84295 5.70577C4.84295 5.70577 4.84295 5.70331 4.84295 5.70085C4.92679 5.50853 4.90459 5.35812 4.79611 5.2521C4.69008 5.14607 4.47804 5.05238 4.16737 4.97595C3.95039 4.91924 3.8419 4.89212 3.62246 4.83787C3.09481 4.71212 2.71264 4.49022 2.38471 4.17461C2.05678 3.85901 1.79049 3.45711 1.4305 2.95905C1.4305 2.95905 1.43051 2.95659 1.42804 2.95413C1.12477 2.53743 0.838751 2.17005 0.668622 1.85444C0.498493 1.53638 0.441784 1.28242 0.569998 1.09256C0.698211 0.902708 1.00642 0.794222 1.50201 0.772032C2.04445 0.747375 2.62634 0.811482 3.20577 0.964351C3.78519 1.11969 4.33503 1.34899 4.80843 1.6498C5.2843 1.95307 5.66401 2.31552 5.90564 2.73468C5.9303 2.77413 5.94016 2.79632 5.96235 2.83577C5.42484 2.84563 5.15363 2.85056 4.61612 2.86289C4.60379 2.84317 4.59639 2.83084 4.5816 2.81111C4.47557 2.66071 4.33996 2.5325 4.17723 2.42647C4.0145 2.32292 3.83697 2.24155 3.64712 2.18731C3.45726 2.13306 3.26987 2.10841 3.08988 2.11334C2.90743 2.11827 2.77921 2.15279 2.70524 2.21689C2.63127 2.27853 2.60662 2.36237 2.62388 2.46346C2.64114 2.56455 2.69784 2.68044 2.78661 2.80619C2.78661 2.80619 2.78661 2.80865 2.78907 2.81111C2.91236 2.98864 3.06276 3.12918 3.25261 3.23028C3.44493 3.33137 3.69889 3.41519 4.02436 3.4793C4.27339 3.52861 4.39667 3.55327 4.64324 3.60258C5.27937 3.73326 5.7725 3.95517 6.07084 4.26584H6.07577ZM12.4396 4.22886C12.4396 4.22886 12.4396 4.23379 12.4396 4.23872C12.4667 5.0154 12.2522 5.68605 11.8676 6.25069C11.6358 6.58848 11.3448 6.87449 11.0218 7.11612C11.0638 7.52542 11.0736 7.95937 11.081 8.50428C10.4843 8.49195 10.186 8.48456 9.58684 8.46976C9.6115 8.22566 9.63123 8.00622 9.64356 7.79911C9.23673 7.91499 8.82003 7.96677 8.4132 7.95444C7.782 7.93718 7.36037 7.77199 7.136 7.46132C6.91162 7.15065 6.88944 6.72408 6.91902 6.17671C6.95108 5.62934 7.03737 4.99074 6.98806 4.24859C6.98806 4.24366 6.98806 4.24365 6.98806 4.23872C6.93628 3.49656 6.76369 2.8555 6.66999 2.31059C6.57383 1.76568 6.55657 1.33666 6.75875 1.02352C6.96094 0.710388 7.38503 0.542727 8.03596 0.525467C8.69428 0.505742 9.39452 0.643814 10.0529 0.937225C10.7087 1.23064 11.2857 1.65966 11.7172 2.21936C12.1486 2.77906 12.41 3.44971 12.4396 4.22639V4.22886ZM10.6693 5.60222C10.7062 5.54305 10.7432 5.4814 10.7753 5.4173C10.938 5.08444 11.0292 4.69239 11.0095 4.24118C11.0095 4.23625 11.0095 4.23626 11.0095 4.23133C10.9898 3.77518 10.864 3.38315 10.6668 3.05275C10.472 2.72235 10.2181 2.47085 9.9345 2.29333C9.65342 2.1158 9.36001 2.03198 9.07646 2.03691C8.80277 2.04184 8.61045 2.13553 8.49457 2.31552C8.37868 2.49551 8.34416 2.74947 8.34663 3.07494C8.35156 3.4004 8.39594 3.78751 8.42306 4.23625C8.42306 4.24119 8.42306 4.24119 8.42306 4.24612C8.44772 4.6924 8.45019 5.07703 8.48224 5.40497C8.51429 5.7329 8.57347 5.98686 8.70414 6.16685C8.83482 6.34685 9.02961 6.44053 9.30083 6.44547C9.39946 6.44547 9.49808 6.43314 9.59424 6.41342C9.52767 6.03618 9.41179 5.6392 9.22193 5.151C9.73232 5.15347 9.98628 5.15594 10.4967 5.1584C10.5608 5.3162 10.615 5.46415 10.6668 5.60469L10.6693 5.60222ZM16.0148 0.513135C16.4413 2.3599 16.5301 3.28452 16.4611 5.13128C16.4438 5.56524 16.3328 5.90303 16.1331 6.14713C15.9359 6.39122 15.6647 6.51204 15.3367 6.51204C15.0088 6.51204 14.782 6.38629 14.6463 6.13973C14.5107 5.89316 14.4762 5.55784 14.5033 5.12635C14.6241 3.29192 14.4713 2.37223 13.7439 0.537793C13.0905 0.547655 12.7626 0.55259 12.1092 0.564919C13.0881 2.45853 13.2828 3.4078 13.0757 5.30141C13.0166 5.85125 13.0018 6.33205 13.093 6.74381C13.1842 7.15804 13.3667 7.48104 13.6847 7.71528C14.0028 7.94951 14.4392 8.07033 14.9817 8.07526C15.5315 8.08019 16.0419 7.96923 16.4758 7.7424C16.9098 7.51556 17.2501 7.19256 17.4892 6.7734C17.7284 6.35671 17.8492 5.86851 17.864 5.31374C17.9108 3.39054 17.8665 2.42648 17.647 0.503278C16.9936 0.505743 16.6657 0.508203 16.0123 0.513135H16.0148ZM22.6917 2.03691C22.7928 1.43036 22.8594 1.12462 23.0246 0.518071C21.2617 0.500811 20.3814 0.498344 18.621 0.50081C18.7442 2.97385 18.7492 5.48634 18.6407 7.96184C20.3444 7.96184 21.1975 7.96184 22.9013 7.94705C22.7583 7.3405 22.7016 7.03476 22.6202 6.42821C21.6315 6.43314 21.1359 6.43561 20.1472 6.43561C20.125 5.83153 20.1201 5.53072 20.1151 4.92664C21.0126 4.92664 21.4589 4.92664 22.3564 4.92664C22.3391 4.35707 22.3441 4.07352 22.3811 3.50396C21.4786 3.50396 21.025 3.5015 20.1225 3.49903C20.1324 2.90974 20.1423 2.61633 20.1669 2.02704C21.1778 2.02704 21.6833 2.03198 22.6942 2.03691H22.6917ZM24.9009 6.41095C24.7678 5.81427 24.7259 5.51592 24.6938 4.91923C25.5913 4.91923 26.0376 4.91677 26.9351 4.91431C26.8932 4.35707 26.9055 4.07846 26.9943 3.52369C26.0918 3.51876 25.6382 3.51629 24.7357 3.51135C24.8023 2.92946 24.859 2.63852 25.0218 2.05663C26.0327 2.06649 26.5381 2.07389 27.549 2.09115C27.7931 1.49693 27.9534 1.20105 28.3479 0.60683C26.585 0.56738 25.7047 0.550121 23.9443 0.530396C23.1183 2.71249 23.0517 5.7255 23.7889 7.93964C25.4927 7.92238 26.3458 7.90759 28.0496 7.87307C27.7019 7.27885 27.5663 6.98298 27.3715 6.38876C26.3828 6.40109 25.8872 6.40602 24.8985 6.41588L24.9009 6.41095ZM29.8224 6.34931C29.8174 6.33452 29.8125 6.32958 29.8076 6.31479C30.1256 4.50254 30.5325 3.61491 33.0499 1.90129C33.4074 1.45255 33.6244 1.22817 34.1348 0.781889C32.1647 0.70792 31.1785 0.675872 29.2084 0.62656C28.7745 1.21831 28.5994 1.51172 28.3331 2.10348C29.4303 2.1232 29.9777 2.13306 31.0749 2.15772C31.0675 2.17251 31.0626 2.17744 31.0552 2.19224C28.8903 3.94284 28.5624 4.84774 28.2148 6.68217C28.4096 7.15064 28.5353 7.38488 28.8336 7.85335C30.7963 7.80897 31.7776 7.78185 33.7403 7.71281C33.1682 7.14571 32.9463 6.86217 32.6258 6.29753C31.5039 6.32219 30.9442 6.33205 29.8224 6.34931ZM37.3253 6.18165C36.3366 6.20877 35.841 6.22356 34.8523 6.24575C34.4824 5.70084 34.3665 5.42716 34.2827 4.88225C35.1802 4.87732 35.6265 4.87485 36.524 4.86746C36.4303 4.3694 36.4574 4.12037 36.6596 3.62231C35.7572 3.60998 35.3035 3.60259 34.4011 3.59273C34.5811 3.06015 34.7388 2.79385 35.1925 2.26127C36.2034 2.29086 36.7089 2.30812 37.7198 2.34264C38.2622 1.81253 38.6173 1.54624 39.5 1.01613C37.7371 0.924899 36.8568 0.885447 35.0964 0.813943C32.5444 3.90093 32.3422 4.3694 34.5761 7.68075C36.2799 7.61911 37.133 7.58459 38.8367 7.50323C38.065 6.97311 37.7642 6.70682 37.3302 6.17671L37.3253 6.18165Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function TransformationWaveLowerIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 40 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.9795 7.08378C7.17519 7.1112 6.77303 7.13862 5.96872 7.22697C5.13089 4.46367 4.71045 3.22065 3.87263 0.5H5.98395C6.41657 2.16651 6.63289 3.00128 7.06856 4.76833C7.08379 4.76833 7.09292 4.76833 7.10816 4.76833C7.62913 2.9434 7.8881 2.08424 8.40908 0.50304H10.1274C10.6453 2.05378 10.9043 2.87333 11.4222 4.71654C11.4374 4.71654 11.4466 4.71654 11.4618 4.71654C11.8975 2.90075 12.1138 2.04769 12.5495 0.50304H14.6547C13.8169 2.99214 13.3964 4.27478 12.5586 7.25439C11.7573 7.17518 11.3552 7.14472 10.5539 7.10816C10.0482 5.31978 9.7953 4.51242 9.28651 2.97387C9.27128 2.97387 9.26213 2.97387 9.2469 2.97387C8.74116 4.52461 8.48829 5.35329 7.9795 7.08378ZM16.4187 7.82411C15.5595 7.66873 15.133 7.59561 14.2739 7.46461C15.3554 4.50023 15.8947 3.28767 16.9732 0.5H19.4745C20.4311 3.29681 21.3055 6.12408 22.1738 8.94832C21.3146 8.7838 20.8881 8.69545 20.0289 8.52484C19.8431 7.83325 19.6816 7.23307 19.5293 6.67858C18.594 6.50797 17.8506 6.37086 16.9153 6.21548C16.766 6.69685 16.6045 7.21783 16.4156 7.82716L16.4187 7.82411ZM18.201 2.1208C17.8567 3.23587 17.5947 4.06152 17.3357 4.88106C17.9603 4.97246 18.4874 5.05472 19.1119 5.15221C18.8499 4.2108 18.5879 3.29376 18.2406 2.12385C18.2284 2.12385 18.2162 2.12385 18.201 2.12385V2.1208ZM26.5792 9.6917C27.548 6.66029 28.328 3.58015 29.1171 0.5H26.829C26.2167 3.55578 25.909 4.91762 25.2966 7.41282C25.2813 7.41282 25.2722 7.40977 25.257 7.40672C24.6446 4.73177 24.3369 3.29377 23.7245 0.5H21.4365C22.3017 3.42172 23.1243 6.35563 23.9743 9.2804C25.0163 9.4632 25.5373 9.57288 26.5792 9.6917ZM35.3809 9.62163V7.80583C33.9978 8.00691 33.3062 8.06175 31.9261 8.11354V6.24595C33.227 6.20025 33.8759 6.15456 35.1768 6.01136V4.25955C33.8759 4.36618 33.227 4.39969 31.9261 4.4393V2.52906C33.3092 2.50469 34.0008 2.48336 35.3809 2.41938V0.50304H29.8848C29.8848 3.65326 29.8848 6.80044 29.8848 9.95066C32.0814 10.0268 33.1813 9.99331 35.3809 9.62467V9.62163ZM2.5382 9.2804C1.7217 9.5028 1.31345 9.63382 0.5 9.94457V17.9633C2.64179 17.945 3.71421 17.9389 5.85599 17.9329V15.9708C4.52766 16.0226 3.86653 16.0561 2.5382 16.1536V9.28345V9.2804ZM13.6706 10.6788C13.9905 11.3856 14.152 12.2082 14.152 13.171V13.1831C14.152 14.1459 13.9905 14.9868 13.6706 15.7149C13.3507 16.44 12.8937 17.0432 12.3027 17.4667C11.7116 17.8902 11.0079 18.1065 10.1883 18.1065C9.38095 18.1065 8.68022 17.8902 8.08917 17.4759C7.49508 17.0615 7.03808 16.4827 6.71819 15.7484C6.39524 15.0142 6.23377 14.155 6.23377 13.1649V13.1527C6.23377 12.1625 6.39525 11.3064 6.72124 10.5813C7.04418 9.85317 7.50423 9.2865 8.09527 8.89348C8.68937 8.50046 9.38705 8.31767 10.1914 8.35118C11.0048 8.38469 11.7086 8.62233 12.3027 9.03058C12.8937 9.43883 13.3507 9.97503 13.6737 10.6819L13.6706 10.6788ZM12.0742 13.0491C12.0742 12.4641 11.998 11.9675 11.8426 11.5501C11.6903 11.1297 11.4709 10.8068 11.1907 10.5722C10.9104 10.3376 10.5752 10.2157 10.1914 10.2066C9.81662 10.2005 9.48758 10.3102 9.20424 10.5356C8.92091 10.7611 8.70155 11.0901 8.54922 11.5166C8.39689 11.9432 8.31767 12.452 8.31767 13.0521V13.0643C8.31767 13.6584 8.39384 14.1763 8.54922 14.6151C8.70155 15.0538 8.92091 15.3981 9.2012 15.6387C9.48149 15.8794 9.81358 16.0013 10.1914 15.9982C10.5844 15.9982 10.9195 15.8703 11.1998 15.6265C11.4801 15.3828 11.6964 15.0355 11.8457 14.5968C11.998 14.1581 12.0742 13.6462 12.0742 13.0643V13.0521V13.0491ZM22.0763 15.459C22.0611 15.459 22.0519 15.459 22.0367 15.4559C21.5187 13.4147 21.2598 12.3088 20.7419 10.0969C20.0564 9.95981 19.7121 9.88973 19.0236 9.75263C18.5026 11.7786 18.2436 12.7962 17.7226 15.005C17.7074 15.005 17.6983 15.005 17.683 15.002C17.2504 12.6926 17.0341 11.5197 16.5984 9.2865C15.7545 9.13112 15.331 9.058 14.4871 8.927C15.2214 11.9249 15.9038 14.935 16.5832 17.945C17.3875 17.9511 17.7897 17.9511 18.594 17.9572C19.0997 15.9221 19.3526 14.9868 19.8614 13.1374C19.8766 13.1374 19.8858 13.1405 19.901 13.1435C20.4067 15.1513 20.6596 16.1414 21.1684 17.9725C21.9697 17.9786 22.3718 17.9785 23.1731 17.9846C24.0109 15.2122 24.4313 13.9418 25.2692 10.9317C24.4283 10.7976 24.0048 10.7215 23.1639 10.5661C22.7283 12.5708 22.512 13.5183 22.0763 15.459ZM26.1039 11.0566C26.1039 14.1977 26.1039 15.5869 26.1039 17.9999C28.3006 18.0121 29.4004 18.0029 31.6001 17.9999V16.7477C30.2169 16.7721 29.5253 16.7721 28.1452 16.766C28.1452 16.2633 28.1452 16.0043 28.1452 15.4742C29.4461 15.4955 30.095 15.4955 31.396 15.4651V14.2038C30.095 14.2373 29.4461 14.2281 28.1452 14.1885C28.1452 13.6432 28.1452 13.3659 28.1452 12.7962C29.5284 12.8724 30.2199 12.8907 31.6001 12.8511V11.407C29.4035 11.4466 28.3036 11.3795 26.1039 11.0596V11.0566ZM39.4939 17.9633C38.5769 17.9694 38.1168 17.9725 37.1998 17.9786C36.6514 17.0006 36.3772 16.5405 35.8288 15.6357C35.8166 15.6357 35.8044 15.6357 35.7862 15.6387C35.7679 15.6418 35.7526 15.6387 35.7344 15.6418C35.3566 15.6722 35.1677 15.6875 34.7899 15.7149V17.9877C33.9734 17.9907 33.5651 17.9907 32.7517 17.9938V11.3582C34.141 11.2759 34.8356 11.1937 36.2249 10.9012C36.8738 10.7672 37.4222 10.7154 37.8761 10.7824C38.327 10.8494 38.6713 11.0322 38.909 11.346C39.1466 11.6598 39.2654 12.1046 39.2654 12.6652V12.6774C39.2654 13.1862 39.1405 13.6767 38.8937 14.1276C38.6469 14.5755 38.3149 14.9136 37.9005 15.1421C38.5403 16.1963 38.8602 16.7416 39.5 17.9603L39.4939 17.9633ZM37.1785 13.1374C37.1785 12.8297 37.0688 12.6012 36.8494 12.458C36.6301 12.3149 36.3406 12.2813 35.9842 12.3423C35.5059 12.4245 35.2682 12.4611 34.7899 12.522V14.4627C35.2713 14.417 35.512 14.3896 35.9964 14.3287C36.3589 14.283 36.6484 14.152 36.8616 13.9357C37.0749 13.7194 37.1815 13.4543 37.1815 13.1435V13.1344L37.1785 13.1374Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function TransformationWaveUpperIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 40 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.77707 10.7326C9.23001 8.47508 8.95648 7.25572 8.40612 4.75766C8.38964 4.75766 8.37975 4.75766 8.36327 4.75766C7.81621 7.22606 7.54266 8.40258 6.9923 10.6732C6.12226 10.6073 5.68725 10.5579 4.81721 10.4063C4.06912 7.10412 3.3309 3.79864 2.54985 0.503055C3.46273 0.503055 3.92081 0.503055 4.83369 0.503055C5.30166 3.21203 5.53565 4.58958 6.00692 7.25572C6.0234 7.25572 6.03328 7.25572 6.04976 7.25901C6.61331 4.68845 6.89344 3.34385 7.45699 0.499756H9.3124C9.87265 3.39328 10.1528 4.80379 10.713 7.4172H10.7559C11.2271 4.78732 11.4644 3.41306 11.9357 0.499756H14.2129C13.4945 3.87444 12.7629 7.24583 11.9456 10.6007C11.0788 10.6798 10.6438 10.7062 9.77707 10.7293V10.7326ZM13.8043 10.3865C14.8226 7.10412 15.7619 3.79864 16.7242 0.499756H19.4299C20.5998 4.0557 21.1831 5.49258 22.3498 8.66953C21.4204 8.86067 20.959 8.96283 20.0296 9.16387C19.8253 8.49486 19.6507 7.91484 19.4859 7.37436C18.4774 7.57539 17.6733 7.73358 16.6649 7.91483C16.5034 8.54429 16.3254 9.2133 16.1244 9.97788C15.195 10.1558 14.7337 10.2415 13.8043 10.3832V10.3865ZM18.0523 2.53314C17.6799 3.96343 17.3965 5.06744 17.1164 6.16158C17.7887 6.05612 18.3588 5.96055 19.0278 5.8452C18.7477 4.89278 18.4643 3.89421 18.0919 2.52984C18.0754 2.52984 18.0655 2.52984 18.049 2.52984L18.0523 2.53314ZM29.8637 0.503055C28.8717 0.503055 28.3774 0.503055 27.3887 0.503055C26.7263 2.40461 26.3934 3.48226 25.731 5.98691C25.7146 5.98691 25.7047 5.99021 25.6882 5.99351C25.0258 3.68989 24.6929 2.65837 24.0305 0.503055C23.0385 0.503055 22.5442 0.503055 21.5555 0.503055C22.6529 3.73932 23.2033 5.1004 24.3007 8.28724C25.4278 8.07632 25.9914 7.96756 27.1185 7.84233C28.2159 4.38196 28.7663 3.04066 29.8637 0.503055ZM36.6361 6.62956C35.1399 6.31647 34.3918 6.2242 32.8989 6.12203V4.62913C34.3062 4.71482 35.0081 4.78732 36.4153 5.00812V3.53829C35.0081 3.3801 34.3062 3.32737 32.8989 3.25816V1.88391C34.3951 1.92675 35.1432 1.9564 36.6361 2.05198V0.506343H30.6909C30.6909 3.06372 30.6909 4.48412 30.6909 7.61163C33.067 7.58527 34.2567 7.66766 36.6361 8.25098V6.62956ZM5.76305 16.7536C5.76305 17.1721 5.63122 17.4885 5.37087 17.7126C5.10722 17.9367 4.73153 18.0389 4.23719 18.0092C3.74285 17.9829 3.36715 17.8346 3.10021 17.5577C2.83656 17.2809 2.70475 16.9085 2.70475 16.4471V11.4873C1.82153 11.2368 1.37992 11.0852 0.5 10.7194V16.3153C0.5 16.9645 0.654881 17.5577 0.961371 18.0554C1.27116 18.553 1.70618 18.9287 2.26643 19.1825C2.82668 19.4362 3.48249 19.5483 4.23059 19.5483C4.97869 19.5483 5.65099 19.4395 6.21124 19.2319C6.77149 19.0243 7.20322 18.7408 7.50971 18.3651C7.8162 17.9927 7.9711 17.5511 7.9711 17.0337V12.2848C7.08788 12.2551 6.64627 12.2189 5.76635 12.1068V16.7503L5.76305 16.7536ZM15.7685 13.0032C16.0321 13.3954 16.1606 13.8831 16.1606 14.4632V14.4731C16.1606 15.0465 16.0288 15.5606 15.7685 16.0055C15.5048 16.4504 15.1357 16.7997 14.6578 17.0601C14.18 17.3204 13.6197 17.4753 12.9738 17.4852C12.3707 17.4951 11.9423 17.5017 11.4842 17.505V19.4362C10.601 19.4362 10.1594 19.4362 9.27944 19.4362V12.3046C9.72434 12.298 10.0572 12.2914 10.39 12.2749C10.5977 12.2617 10.7789 12.2518 10.9536 12.2419C11.1151 12.2321 11.2897 12.2189 11.4842 12.2024C11.9423 12.1694 12.3707 12.1233 12.9738 12.0541C13.6197 11.9783 14.18 12.008 14.6578 12.176C15.1357 12.3408 15.5048 12.6176 15.7685 13.0098V13.0032ZM13.9328 14.8026C13.9328 14.394 13.801 14.1007 13.5406 13.9227C13.277 13.7447 12.9145 13.659 12.4498 13.692C12.0675 13.7184 11.7742 13.7381 11.4875 13.7546V16.1472C11.7742 16.1406 12.0675 16.134 12.4498 16.1209C12.9145 16.1077 13.277 16.0088 13.5406 15.7715C13.8043 15.5342 13.9328 15.2146 13.9328 14.8125V14.8026ZM23.6317 11.451C23.8954 11.8794 24.0239 12.4265 24.0239 13.0922V13.1054C24.0239 13.7678 23.8921 14.3742 23.6317 14.9114C23.3681 15.4486 22.999 15.8803 22.5211 16.2C22.0433 16.5196 21.483 16.7075 20.8371 16.7734C20.234 16.836 19.8056 16.8788 19.3475 16.925V19.4C18.4643 19.4066 18.0227 19.4099 17.1427 19.4132C17.1427 16.3647 17.1427 14.7466 17.1427 11.3291C17.5876 11.2368 17.9205 11.1676 18.2533 11.0984C18.4873 11.0489 18.6917 11.0028 18.8861 10.9633C19.0278 10.9336 19.1794 10.9006 19.3475 10.8644C19.8056 10.7655 20.234 10.6732 20.8371 10.5414C21.483 10.403 22.0433 10.4096 22.5211 10.5711C22.999 10.7326 23.3681 11.0259 23.6317 11.4543V11.451ZM21.7961 13.4712C21.7961 13.0032 21.6643 12.677 21.4039 12.4891C21.1403 12.3046 20.7778 12.2584 20.3131 12.354C19.9308 12.4298 19.6375 12.4891 19.3508 12.5484C19.3508 13.547 19.3508 14.417 19.3508 15.2838C19.6375 15.2409 19.9308 15.1981 20.3131 15.1388C20.7778 15.0696 21.1403 14.8949 21.4039 14.6115C21.6676 14.3248 21.7961 13.9491 21.7961 13.4844V13.4712ZM30.9512 11.1148C30.9512 10.314 30.9512 9.91855 30.9512 9.13749C28.5751 9.14738 27.3854 9.28251 25.006 9.70105C25.006 12.9208 25.006 16.1406 25.006 19.3604C27.3821 19.3472 28.5718 19.3505 30.9512 19.3538V17.1524C29.455 17.1326 28.707 17.1359 27.2141 17.1524C27.2141 16.2955 27.2141 15.877 27.2141 15.0531C28.6213 15.0168 29.3232 15.0069 30.7304 15.0267V13.0724C29.3232 13.056 28.6213 13.0724 27.2141 13.1416V11.2467C28.7102 11.1313 29.4583 11.0951 30.9512 11.1116V11.1148ZM39.4934 19.3967C38.5014 19.3868 38.0038 19.3835 37.0118 19.3769C36.4186 18.0356 36.122 17.3303 35.5288 15.9099C35.5156 15.9099 35.5024 15.9099 35.4827 15.9066C35.4629 15.9033 35.4464 15.9066 35.4267 15.9033C35.018 15.8671 34.8137 15.8539 34.405 15.8242V19.3637C33.5218 19.3604 33.0802 19.3604 32.2003 19.3571C32.2003 15.9594 32.2003 12.5616 32.2003 9.16057C33.7031 9.22318 34.4545 9.30557 35.9572 9.62525C36.6592 9.77355 37.2524 10.0603 37.7434 10.4458C38.2345 10.8314 38.6036 11.2961 38.8607 11.8201C39.1177 12.3441 39.2462 12.911 39.2462 13.5305V13.5437C39.2462 14.1072 39.1111 14.5752 38.8442 14.9773C38.5772 15.3793 38.218 15.6562 37.7698 15.8078C38.4619 17.3303 38.8079 18.0685 39.5 19.4L39.4934 19.3967ZM36.9855 12.9769C36.9855 12.5814 36.8668 12.2386 36.6296 11.9486C36.3923 11.6586 36.0792 11.4741 35.6903 11.4049C35.1729 11.3159 34.9158 11.2763 34.3984 11.2137V13.9688C34.9191 14.0183 35.1795 14.0479 35.7035 14.1138C36.0956 14.1633 36.4087 14.0875 36.6394 13.8832C36.8701 13.6788 36.9855 13.3855 36.9855 12.9868V12.9736V12.9769Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function TransformationWaveIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 40 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0932 1.72664L13.3602 11.5362L11.0801 12.2L8.04953 7.15273L8.00623 7.16716L8.15415 13.0514L5.86682 13.7153L0.833984 5.29112L3.23676 4.59482L6.22038 10.259L6.26367 10.2446L5.99309 3.79389L7.9449 3.22747L11.1666 8.81952L11.2099 8.80508L10.6976 2.42294L13.0932 1.72664ZM20.1644 1.12414L24.2664 10.2626L21.7374 10.508L20.9473 8.49482L17.8699 8.79426L17.4838 10.9192L14.9548 11.1646L17.2169 1.40555L18.7105 1.26124L20.1644 1.12054V1.12414ZM20.2835 6.80999L18.9089 3.32127H18.862L18.191 7.01203L20.2799 6.80999H20.2835ZM27.7299 8.05467H27.683L25.7817 0.943754L23.0723 0.976223L26.193 10.4358L29.2776 10.3997L32.1711 0.8716L29.4616 0.904069L27.7299 8.05828V8.05467ZM39.7257 8.04385L35.6381 8.26753L35.5335 6.34819L39.3758 6.13894L39.2748 4.32423L35.4325 4.53348L35.3315 2.66105L39.4191 2.43737L39.3145 0.5L32.8169 0.857166L33.3364 10.3384L39.834 9.98122L39.7294 8.04385H39.7257Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function Tool01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M14.6314 6.63137C14.2354 6.23535 14.0373 6.03735 13.9632 5.80902C13.8979 5.60817 13.8979 5.39183 13.9632 5.19098C14.0373 4.96265 14.2354 4.76465 14.6314 4.36863L17.4697 1.53026C16.7165 1.18962 15.8804 1 15 1C11.6863 1 9 3.68629 9 7C9 7.49104 9.05899 7.9683 9.17026 8.42509C9.28942 8.91424 9.349 9.15882 9.33842 9.31333C9.32735 9.47509 9.30323 9.56115 9.22863 9.70511C9.15738 9.84262 9.02086 9.97914 8.74782 10.2522L2.5 16.5C1.67157 17.3284 1.67157 18.6716 2.5 19.5C3.32842 20.3284 4.67157 20.3284 5.5 19.5L11.7478 13.2522C12.0209 12.9791 12.1574 12.8426 12.2949 12.7714C12.4388 12.6968 12.5249 12.6727 12.6867 12.6616C12.8412 12.651 13.0858 12.7106 13.5749 12.8297C14.0317 12.941 14.509 13 15 13C18.3137 13 21 10.3137 21 7C21 6.11959 20.8104 5.28347 20.4697 4.53026L17.6314 7.36863C17.2354 7.76465 17.0373 7.96265 16.809 8.03684C16.6082 8.1021 16.3918 8.1021 16.191 8.03684C15.9627 7.96265 15.7646 7.76465 15.3686 7.36863L14.6314 6.63137Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ReflectHorizontalIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 12L18 12M13.5 12L10.5 12M6 12L3 12M16.0094 3.28777L12.6341 7.67567C12.4183 7.95616 12.3105 8.09641 12.179 8.14681C12.0637 8.19098 11.9363 8.19098 11.821 8.14681C11.6895 8.09641 11.5817 7.95616 11.3659 7.67567L7.99059 3.28777C7.67243 2.87415 7.51334 2.66735 7.51547 2.49387C7.51732 2.34295 7.58725 2.20094 7.70574 2.10745C7.84195 2 8.10286 2 8.62469 2L15.3753 2C15.8971 2 16.1581 2 16.2943 2.10745C16.4128 2.20094 16.4827 2.34295 16.4845 2.49387C16.4867 2.66735 16.3276 2.87415 16.0094 3.28777ZM16.0094 20.7122L12.6341 16.3243C12.4183 16.0438 12.3105 15.9036 12.179 15.8532C12.0637 15.809 11.9363 15.809 11.821 15.8532C11.6895 15.9036 11.5817 16.0438 11.3659 16.3243L7.99059 20.7122C7.67243 21.1258 7.51334 21.3327 7.51547 21.5061C7.51732 21.657 7.58724 21.7991 7.70574 21.8925C7.84195 22 8.10286 22 8.62469 22L15.3753 22C15.8971 22 16.1581 22 16.2943 21.8925C16.4128 21.7991 16.4827 21.6571 16.4845 21.5061C16.4867 21.3327 16.3276 21.1258 16.0094 20.7122Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ReflectVerticalIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3V6M12 10.5V13.5M12 18V21M3.28777 7.99059L7.67567 11.3659C7.95617 11.5817 8.09641 11.6895 8.14681 11.821C8.19098 11.9363 8.19098 12.0637 8.14681 12.179C8.09641 12.3105 7.95617 12.4183 7.67567 12.6341L3.28777 16.0094C2.87415 16.3276 2.66735 16.4867 2.49387 16.4845C2.34295 16.4827 2.20094 16.4128 2.10745 16.2943C2 16.1581 2 15.8971 2 15.3753V8.62469C2 8.10286 2 7.84195 2.10745 7.70574C2.20094 7.58724 2.34295 7.51732 2.49387 7.51547C2.66735 7.51334 2.87415 7.67243 3.28777 7.99059ZM20.7122 7.99059L16.3243 11.3659C16.0438 11.5817 15.9036 11.6895 15.8532 11.821C15.809 11.9363 15.809 12.0637 15.8532 12.179C15.9036 12.3105 16.0438 12.4183 16.3243 12.6341L20.7122 16.0094C21.1258 16.3276 21.3327 16.4867 21.5061 16.4845C21.6571 16.4827 21.7991 16.4128 21.8925 16.2943C22 16.1581 22 15.8971 22 15.3753V8.62469C22 8.10286 22 7.84195 21.8925 7.70574C21.7991 7.58724 21.6571 7.51732 21.5061 7.51547C21.3327 7.51334 21.1258 7.67243 20.7122 7.99059Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Copy07Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 2.0028C9.82495 2.01194 9.4197 2.05103 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8.05103 3.4197 8.01194 3.82495 8.0028 4.5M19.5 2.0028C20.1751 2.01194 20.5803 2.05103 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C21.949 3.4197 21.9881 3.82494 21.9972 4.49999M21.9972 13.5C21.9881 14.175 21.949 14.5803 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.5803 15.949 20.1751 15.9881 19.5 15.9972M22 7.99999V9.99999M14.0001 2H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function RatioSquareSolidIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  )
}

export function RatioPortrait4by3SolidIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="1" width="12" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  )
}

export function RatioPortrait16by9SolidIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4" y="1" width="10" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  )
}

export function RatioLandscape4by3SolidIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="3" width="16" height="12" rx="2" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  )
}

export function RatioLandscape16by9SolidIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="4" width="16" height="10" rx="2" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  )
}

export function AngleIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 16.5H4V4.5M4 9.75C7.72792 9.75 10.75 12.7721 10.75 16.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function RemoveMaskIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="15"
        cy="12"
        r="7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="9"
        cy="12"
        r="7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle opacity="0.5" cx="9" cy="12" r="7" fill="currentColor" />
    </svg>
  )
}
